import { mergeStyleSets } from '@fluentui/react';
import { DropdownItemProps } from '@fluentui/react-northstar';
import { uniqueId } from 'lodash';
import React from 'react';
import { ToastOptions } from 'react-toastify';
import AdeleIgm from '../../../images/Adele.png';
import { PersonCardMention } from '../components/TicketConversation/components/PersonCardOnMention';
import { i18n, toCapitalizeCase, toTitleCase } from './helper';
const { t } = i18n();

export const TICKET_PAGINATION = {
  ITEM_PER_PAGE: () => parseInt(localStorage.getItem('ticketListItemPerPage') || '25', 10),
  ITEM_PER_REQUEST_PAGE: () => parseInt(localStorage.getItem('requestListItemPerPage') || '25', 10)
};
export const APPROVAL_PAGINATION = {
  ITEM_PER_PAGE: () => parseInt(localStorage.getItem('approvalListItemPerPage') || '25', 10)
};

const toDropdownItem = (item) => ({
  key: item["key"],
  value: item["value"],
  label: item["key"],
  header: item["key"]
})

export const TICKET_ITEM_PER_PAGE =  [
  toDropdownItem({
    key: t('preferences.pagination.25-per-page'),
    value: '25'
  }),
  toDropdownItem({
    key: t('preferences.pagination.50-per-page'),
    value: '50'
  }),
  toDropdownItem({
    key: t('preferences.pagination.100-per-page'),
    value: '100'
  }),
]

export const ENTITY_TYPE = {
  Ticket: "ServiceDesk.Core.Models.Ticket",
  Approval: "ServiceDesk.Core.Models.TicketApprovals.Approvals",
  SLA: "ServiceDesk.Core.Models.SLA.TicketSla",
  Task: "ServiceDesk.Core.Models.TicketTask",
  Lifecycle: "ServiceDesk.Core.Models.TicketFlow.TicketLifecycle",
  Resolution: "ServiceDesk.Core.Models.Resolution",
}

export const ACTIVITY_ACTION = {
  MERGED: 'merged',
  RELATED: 'related',
  UNRELATED: 'unrelated',
  COMMENTED: 'commented',
  REMOVED: 'removed',
  ADDED: 'added',
  CHANGED: 'changed',
  UPDATED: 'updated',
  DELETED: 'deleted',
  CREATED: 'created',
  RENAMED: 'renamed',
  ATTACHED: 'attached',
  ASSIGNED: 'assigned',
  APPROVED: 'approved',
  DECLINED: 'declined',
  RESET_VOTES_FOR: 'reset votes for',
  TRANSITIONED: 'transitioned',
  FILLED: 'filled',
};

export const ACTIVITY_FIELD = {
  AFFECTED_USERS: 'AffectedUsers',
  INIT: 'Init',
  TAG: 'Tag',
  STATUS: 'Status',
  ASSIGNEE: 'Assignee',
  IS_MERGED: 'IsMerged',
  COMMENTS: 'Comments',
  REQUESTER: 'Requester',
  CARD_ANSWER: 'CardAnswerJson',
  RESOLUTATION_DATE: 'ResolutionDate',
  DUE_DATE: 'DueDate',
  RELATE_TICKET: 'RelatedTickets',
  FILE_ATTACHMENT: 'FileAttachment',
  CARD_TEMPLATE: 'CardTemplateJson',
  SURVEY: 'Survey',
  TICKET_APPROVAL: 'TicketApprovals',
  APPROVERS: 'Approvers',
  APPROVAL: 'Approval',
  TICKET_TASK: "Task",
  TICKET_TASKS: "TicketTasks",
  TIME_ENTRIES: "TimeEntries",
  LIFECYCLE: "TicketLifecycle",
  LIFECYCLE_PHASE: "TicketLifecyclePhase",
  LIFECYCLE_STATUS: "TicketLifecycleStatus",
  TICKET_COLLABORATORS: 'TicketCollaborators',
  TASK_COLLABORATORS: 'TaskCollaborators',
  TICKET_RESOLUTION_NOTE: 'Note',
  TICKET_RESOLUTIONNOTE_INTERNAL: 'InternalNote',
  TICKET_RESOLUTION_DRAFT_KB: 'DraftKB',
  TICKET_RESOLUTION_CATEGORY: 'ResolutionCategory',
  GROUP_CHAT: 'GroupChat',
  TICKET_CUSTOM_FORMS: 'CustomForms',
  TICKET_CUSTOM_FORM: 'CustomForm',
  TICKET_CUSTOM_FORM_ANSWER: "CustomFormAnswer",
  CUSTOM_PROPERTIES: 'CustomPropertiesAnswerJson'
};

export const ACTIVITY_TASK_FILED = {
  TITLE: "Title",
  STATUS_ID: "StatusId",
  ASSIGNEE_ID: "AssigneeId",
  LIFECYCLE_PHASE: "LifecyclePhase",
  TEAM_ID: "TeamId",
  SUPPORTGROUP_ID: "SupportGroupId",
  COLLABORATORS: "TaskCollaborators",
  TEAM: "Team"
}

export const STATUS = {
  STATUS: t('status.status'),
  GETTING_ALL_STATUSES: t('status.getting-all-statuses'),
  INPUT_PLACEHOLDER: t('status.input-placeholder'),
  NEW_STATUS: t('status.new-status'),
  UPDATING_STATUS: t('status.updating-status'),
  CREATING_NEW_STATUS: t('status.creating-new-status'),
  FETCHING_STATUS_DEFAULT_INSTANCE: t('status.fetching-status-default-instance'),
  FETCHING_STATUS_DETAILS: t('status.fetching-status-details'),
};

export const STATUS_GUID = {
  ACTIVE: '1a2c8296-d733-43a6-8f15-63f86618f7f8',
  PENDING: '9446fd6f-69de-4e36-81e4-6241e2e0fd8e',
  CLOSED: 'd218170f-b01a-45a1-81d3-8ce3cee92a63',
  DEFLECTED: 'd45d1c82-1e10-44fc-a10c-54b9d7c40c1a',
  RESOLVED: '3018134d-1ca5-4fb6-a079-dc05959f3acc',
};

export const STATUS_VALUE = {
  ACTIVE: 'Active',
  PENDING: 'Pending',
  CLOSED: 'Closed',
  DEFLECTED: 'Deflected',
  RESOLVED: 'Resolved',
};

export const TASK_STATUS_GUID = {
  NOT_STARTED: '77130d3f-e795-497e-bbbb-780910efa501',
  IN_PROGRESS: '86873792-6194-4147-8fa0-0d808096a8f8',
  COMPLETED: 'eec5783c-e3b4-4a27-ae98-e5761b77d523',
  FAILED: '6b26ede9-1373-41c2-926c-d46eede98eb8',
  SKIPPED: 'acaeeb0c-d4e4-479e-9d25-b548e73c0a35'
}

export const POWERAUTOMATE_TASK_STATUS_GUID = {
  SUCCEEDED: '85bc29f1-8f5a-476b-90b9-016964d906f0',
  CANCELLED: '3926607e-b100-4785-b5c0-7caba398214b',
  FAILED: 'feffbb01-2f46-4f97-b6aa-4fdbc4838040'
}

export const LIFECYCLE_STATUS_GUID = {
  NOT_STARTED: 'f1c36725-aad7-4224-819f-2e959aaeca64',
  IN_PROGRESS: '0866fa2d-80d4-4090-9ff3-93134f821c90',
  COMPLETED: 'fb2371fd-22fd-4582-b613-ffc51abf979b',
  FAILED: '35e52b9d-338b-4eb8-a087-26388d9a1c6d'
}

export const PRIORITY = {
  PRIORITY: t('priority.priority'),
  GETTING_ALL_PRIORITIES: t('priority.getting-all-priorities'),
  INPUT_PLACEHOLDER: t('priority.input-placeholder'),
  NEW_PRIORITY: t('priority.new-priority'),
  UPDATING_PRIORITY: t('priority.updating-priority'),
  CREATING_NEW_PRIORITY: t('priority.creating-new-priority'),
  FETCHING_PRIORITY_DEFAULT_INSTANCE: t('priority.fetching-priority-default-instance'),
  FETCHING_PRIORITY_DETAILS: t('priority.fetching-priority-details'),
  ADD_NEW_PRIORITY: t('priority.add-new-priority'),
  ENTER_INFORMATION: t('priority.enter-information'),
};

export const CATEGORY = {
  CATEGORY: t('category.category'),
  GETTING_ALL_CATEGORIES: t('category.getting-all-categories'),
  INPUT_PLACEHOLDER: t('category.input-placeholder'),
  NEW_CATEGORY: t('category.new-category'),
  UPDATING_CATEGORY: t('category.updating-category'),
  CREATING_NEW_CATEGORY: t('category.creating-new-category'),
  FETCHING_CATEGORY_DEFAULT_INSTANCE: t('category.fetching-category-default-instance'),
  FETCHING_CATEGORY_DETAILS: t('category.fetching-category-details')
};

export const TICKET_TYPE = {
  TICKET_TYPE: t('ticket-types.ticket-type'),
  TICKET_TYPES: t('ticket-types.ticket-types'),
  GETTING_ALL_TICKET_TYPES: t('ticket-types.getting-all-ticket-types'),
  INPUT_PLACEHOLDER: t('ticket-types.input-placeholder'),
  NEW_TICKET_TYPE: t('ticket-types.new-ticket-type'),
  UPDATING_TICKET_TYPE: t('ticket-types.updating-ticket-type'),
  CREATING_NEW_TICKET_TYPE: t('ticket-types.creating-new-ticket-type'),
  FETCHING_TICKET_TYPE_DEFAULT_INSTANCE: t('ticket-types.fetching-ticket-type-default-instance'),
  FETCHING_TICKET_TYPE_DETAILS: t('ticket-types.fetching-ticket-type-details')
};

export const BILLING = {
  BILLING: t('billing.breadcrumb-title'),
  ACCOUNT_EMAIL: t('billing.email'),
  ACCOUNT_EMAIL_PLACEHOLDER: 'Enter account email',
  COUNT: t('billing.count'),
  BILLING_PLAN: t('billing.billing-plan'),
  BILLING_SUMMARY: 'Summary',
  Next_BILLING_DATE: t('billing.next-billing-date'),
  STREET_ADDRESS: t('billing.street-address'),
  STREET_ADDRESS_2: t('billing.street-address-2'),
  CITY: t('billing.city'),
  STATE_PROVINCE: t('billing.state'),
  POSTAL_ZIPCODE: t('billing.zip-code'),
  COUNTRY: t('billing.country'),
  SETUP_PAYMANT: 'Setup Payment',
  CANCEL_SUBSCRIPTION: 'Cancel Subscription',
  CARD_INFORMATION: t('billing.card-information'),
  EXPIRY_DATE_PLACEHOLDER: 'MM / YY',
  CVC_PLACEHOLDER: 'CVC',
  SETUP_PAYMENT: 'Update Payment Method',
  LICENSE_CANCEL_SUCCESS: 'Your subscription was canceled.',
  LICENSE_CANCEL_ERROR: 'There was an error canceling your subscription.',
  CHECKOUT_ERRROR: t('billing.checkout-error'),
  NUMBER_OF_AGENTS: t('billing.num-licensed-agents')
};

export const SECURITY = {
  SECURITY: t('security.security'),
  APPLICATION_ROLES: t('security.application-roles'),
  MAPPED_ROLES: t('security.mapped-roles'),
  MAPPED_ROLE: t('security.mapped-role'),
  ADD_MAPPED_ROLE: t('security.add-mapped-role'),
  LABEL_PLACEHOLDER: t('security.label-placeholder'),
  FETCHING_ROLES: t('security.fetching-roles'),
  CREATING_ROLES: t('security.creating-roles'),
};

export const BUTTONS = {
  SAVE: t('common.buttons.save'),
  UPDATE: t('common.buttons.update'),
  EDIT: t('common.buttons.edit'),
  CANCEL: t('common.buttons.cancel'),
  CONFIRM: t('common.buttons.confirm'),
  DELETE: t('common.buttons.delete'),
  OK: t('common.buttons.ok'),
  SUBMIT: t('common.buttons.submit'),
};

export const ACCESS_TOKEN = {
  TOKEN: t('access-token.token'),
  GETTING_ALL_ACCESST_TOKENS: t('access-token.getting-all-accesst-tokens'),
  INPUT_PLACEHOLDER: t('access-token.input-placeholder'),
  NEW_ACCESS_TOKEN: t('access-token.new-access-token'),
  UPDATING_ACCESS_TOKEN: t('access-token.updating-access-token'),
  CREATING_NEW_ACCESS_TOKEN: t('access-token.creating-new-access-token'),
  FETCHING_ACCESS_TOKEN_DEFAULT_INSTANCE:  t('access-token.fetching-access-token-default-instance'),
  FETCHING_ACCESS_TOKEN_DETAILS: t('access-token.fetching-access-token-details'),
  ADD_NEW_ACCESS_TOKEN: t('access-token.add-new-access-token'),
  ENTER_INFORMATION: t('access-token.enter-information'),
};

export const SETTINGS = t('common.settings');
export const LOADING = t('common.loading');
export const ERROR = 'error';
export const DONE = t('common.done');
export const WARNING = 'warning';
export const DELETE = t('common.buttons.delete');
export const AND = t('common.and');
export const OR = t('common.or');
export const SAVE = t('common.buttons.save');

export const USERS = t('users.users');
export const GETTING_ALL_USERS = t('users.getting-all-users');
export const SYNC_USERS = t('users.sync-users');
export const UPDATE_ALL_USERS = t('users.update-all-users');
export const UPDATE = t('users.update');

export const USER_FORM = {
  HELPBOT_INSTALL_ERRROR: 'There was an error installing Helpbot.',
  HELPBOT_UPDATE_ERRROR: 'There was an error updating Helpbot.',
  TIKIT_INSTALL_ERRROR: 'There was an error installing Tikit.',
  TIKIT_UPDATE_ERRROR: 'There was an error updating Tikit.',
  TVA_INSTALL_ERRROR: 'There was an error installing TVA.',
  TVA_UPDATE_ERRROR: 'There was an error updating TVA.',
  HELPBOT_INSTALL_SUCCESS: 'Helpbot installed successfully.',
  HELPBOT_UPDATE_SUCCESS: 'Helpbot updated successfully.',
  TIKIT_INSTALL_SUCCESS: 'Tikit installed successfully.',
  TIKIT_UPDATED_SUCCESS: 'Tikit updated successfully.',
  TVA_INSTALL_SUCCESS: 'TVA installed successfully.',
  TVA_UPDATED_SUCCESS: 'TVA updated successfully.'
};

export const KNOWLEDGE_BASE = 'knowledge';
export const LICENSE_DISTRIBUTION = 'License Distribution';
export const GETTING_ALL_LICENSE = t('billing.license.getting-licenses');

export const GROUPS = t('groups.groups');
export const NEW_GROUP = t('groups.new-group');
export const GETTING_ALL_GROUPS = t('groups.getting-all-groups');

export const TEAMS = t('teams.teams');
export const NEW_TEAM = t('teams.new-team');
export const GETTING_ALL_TEAMS = t('teams.getting-all-teams');

export const TEMPLATES = t('template.template');
export const NEW_TEMPLATE = t('template.new-template');
export const GETTING_ALL_TEMPLATES = t('template.getting-all-templates');
export const GETTING_TEMPLATE_DATA = t('template.getting-template-data');
export const SAVING_TEMPLATE_DATA = t('template.saving-template-data');

export const REFRESH_SESSION = t('common.refresh-session');
export const LIST = 'list';
export const DEFAULT = t('common.default');
export const NAME = t('common.name');
export const VALUE = 'value';
export const EMAIL = 'email';
export const ADD = 'add';
export const UNAUTHORIZED_ACCESS = t('common.unauthorized-access');
export const SOMETHING_WENT_WRONG = t('common.something-went-wrong');
export const CONTACT_ADMIN = t('common.please-contact-your-administrator');

export const SURVEY = t('surveys.surveys');

export const TREE_LISTING_CONSTANTS = {
  edit: t('common.tree-listing-constants.edit'),
  default: t('common.tree-listing-constants.default'),
  archive: t('common.tree-listing-constants.archive'),
  archived: t('common.tree-listing-constants.archived'),
  unArchive: t('common.tree-listing-constants.unArchive'),
  system: t('common.tree-listing-constants.system'),
  guid: {
    "1a2c8296-d733-43a6-8f15-63f86618f7f8": t('status-constants.active'),
    "9446fd6f-69de-4e36-81e4-6241e2e0fd8e": t('status-constants.pending'),
    "3018134d-1ca5-4fb6-a079-dc05959f3acc": t('status-constants.resolved'),
    "d218170f-b01a-45a1-81d3-8ce3cee92a63": t('status-constants.closed'),
    "d45d1c82-1e10-44fc-a10c-54b9d7c40c1a": t('status-constants.deflected'),
    "e4fe7f4b-c709-4aa4-b0c5-895a542e3fa7": t('tickettype-constants.request'),
    "b420e1d9-481a-4195-87bf-440c8b269e3f": t('tickettype-constants.incident'),
    "0773e3a9-b56e-4a50-8aeb-8ff9fe82aae8": t('tickettype-constants.change'),
  },
  delete: t('common.tree-listing-constants.delete'),
};

export const DEFAULT_API_STATUS = {
  status: LOADING,
  msg: '',
  errCode: 0
};

export const LIFECYCLE_HEADERS: string[] = ['lifecycle', 'description'];
export const ARCHIVE_MODAL_HEADER = t('common.archive-modal-header');
export const UNARCHIVE_MODAL_HEADER = t('common.unarchive-modal-header');
export const ARCHIVE_CONFIRMATION_SUBTITLE =  t('common.archive-confirmation-subtitle');
export const UNARCHIVE_CONFIRMATION_SUBTITLE =  t('common.unarchive-confirmation-subtitle');
export const ARCHIVE_CONFIRMATION = t('common.archive-confirmation');
export const UNARCHIVE_CONFIRMATION = t('common.unarchive-confirmation');
export const ARCHIVE_CONFIRMATION_WARNING =  t('common.archive-confirmation-warning');

export const TAG_HEADERS: string[] = [
  t('ticket.add-ticket.tags.name'),
  t('ticket.ticket-list.created-date'),
  t('ticket.ticket-list.modified-date'),
  '',
];
export const USERS_HEADERS: string[] = [t('users.name'), t('users.email', 'licenses')];
export const GROUPS_HEADERS: string[] = [
  t('groups.name'),
  t('teams.teams-columns.team'),
  t('teams.teams-columns.triage-channel'),
  t('groups.members'),
  t('groups.description'),
  t('ticket.ticket-list.created-date'),
  t('ticket.ticket-list.last-modified-date'),
  '',
];
export const TEAMS_HEADERS: string[] = [
  t('teams.teams-columns.friendly-name'),
  t('teams.teams-columns.team'),
  t('teams.teams-columns.triage-channel'),
  t('teams.teams-columns.email'),
  t('teams.teams-columns.description'),
  t('ticket.ticket-list.created-date'),
  t('ticket.ticket-list.modified-date'),
  '',
];
export const USER_LICENSE_HEADERS: string[] = [t('billing.license.agent'), t('billing.license.licensed')];
export const AUTOMATION_HEADERS: string[] = [
  t('automation.headers.title'),
  t('automation.headers.description'),
  t('automation.headers.status'),
  t('automation.headers.created-date'),
  t('automation.headers.modified-date'),
  t('automation.headers.action')
];
export const KB_HEADERS: string[] = ['questions', 'answer', 'options'];
export const TEMPLATE_HEADERS = [
  { id: 'name', title: t('template.template-headers.name') },
  { id: 'ticketCount', title: t('template.template-headers.ticket-count') },
  { id: 'team', title: t('template.fields.team') },
  { id: 'group', title: t('template.fields.group') },
  { id: 'assignee', title: t('template.fields.assignee') },
  { id: 'customFormsExist', title: t('template.template-headers.custom-forms-exist') },
  { id: 'lifecycle', title: t('template.fields.lifecycle') },
  { id: 'createdDate', title: t('template.template-headers.created-date') },
  { id: 'modifiedDate', title: t('template.template-headers.modified-date') },
  { id: 'availableTo', title: t('scoping.available-to') },
  { id: 'empty', title: '' },
];
export const SLA_HEADERS: string[] = [
  t('sla.headers.name'),
  t('sla.headers.ticket-related-to-sla'),
  t('sla.headers.ticket-breached-sla'),
  t('sla.headers.created-date'),
  t('sla.headers.modified-date'),
  t('sla.headers.action'),
];

export const DATASOURCE_HEADERS: string[] = [
  t('template.datasource-headers.name'),
  t('template.datasource-headers.type'),
  ''
];

export const TAGS = {
  TAGS: t('ticket.add-ticket.tag'),
  TAG: t('ticket.add-ticket.tags.title'),
  GETTING_ALL_TAGS: t('ticket.add-ticket.tags.getting-all-tags'),
  DELETING_TAGS: t('ticket.add-ticket.tags.deleting-tag'),
  FETCHING_TAGS_DEFAULT_INSTANCE: t('ticket.add-ticket.tags.fetching-tags-default-instance'),
  FETCHING_TAGS_DETAILS: t('ticket.add-ticket.tags.fetching-tags-details'),
  CREATING_NEW_TAGS: t('ticket.add-ticket.tags.creating-new-tags'),
  UPDATE_TAGS: t('ticket.add-ticket.tags.updateing-tag'),
  SELECT_TAGS: t('ticket.add-ticket.tags.select-tags'),
  FETCHING_TAG_DETAILS: t('ticket.add-ticket.tags.fetching-tags-details')
};

export const AUTOMATION = {
  AUTOMATION: t('automation.automation'),
  ADD_NEW_AUTOMATION: t('automation.add-new-automation'),
  ADD_INFORMATION_NEW_AUTOMATION: t('automation.add-information-new-automation'),
  INFORMATION: t('automation.information'),
  GETTING_ALL_AUTOMATION: t('automation.getting-all-automation'),
  DELETING_AUTOMATION: t('automation.deleting-automation'),
  TOGGLING_AUTOMATION: t('automation.toggling-automation'),
  FETCHING_AUTOMATION_DEFAULT_INSTANCE: t('automation.fetching-automation-default-instance'),
  FETCHING_AUTOMATION_DETAILS: t('automation.fetching-automation-details'),
  CREATING_NEW_AUTOMATION: t('automation.creating-new-automation'),
  UPDATE_AUTOMATION: t('automation.update-automation'),
};

export const SETTINGS_PAGES = {
  SECURITY: 'security',
  AUTOMATION: 'automation',
  CATEGORY: 'category',
  RESOLUTIONCATEGORY: 'resolution-category',
  PREFERENCES: 'preferences',
  TICKET_TYPES: 'ticket-types',
  PRIORITY: 'priority',
  STATUS: 'status',
  TAGS: 'tags',
  KNOWLEDGE: 'servicecatalog',
  GROUPS: 'groups',
  USERS: 'users',
  BOT_CONFIGURATION: 'botconfiguration',
  FEATURE_CONFIGURATION: 'feature-config',
  MS_TEAMS: 'microsoftteams',
  MS_TEAMS_TITLE: 'microsoft teams',
  BILLING: 'billing',
  EMAIL_CONNECTOR: 'email-connector',
  NOTIFICATION_CENTER: 'notification-center',
  EMAIL_CONNECTOR_TITLE: 'email connector',
  TEMPLATES: 'templates',
  ACCESS_TOKEN: 'token',
  SLA: 'sla',
  TEAMS: 'teams',
  SURVEYS: 'surveys',
  LIFECYCLE: 'lifecycle',
  AI_CONFIG: 'aiconfiguration',
  TIKIT_CONFIGURATION: 'ticket-configuration',
  SERVICE_OFFERING: 'service-offerings',
  FORMS: 'forms',
  CUSTOM_PROPERTIES: 'custom-properties'
};

export const SIDENAV_ARRANGED_KEYS = [
  'tickets',
  'mywork',
  'mygroupwork',
  SETTINGS_PAGES.KNOWLEDGE,
  SETTINGS_PAGES.USERS,
];

export const SIDENAV_AGENTS_KEYS = [
  'tickets',
  'mywork',
  'mygroupwork',
  SETTINGS_PAGES.USERS,
];


export const SIDENAV_KBAGENTS_KEYS = [
  SETTINGS_PAGES.KNOWLEDGE,
];


export const ARRANGED_SETTING_KEYS = [
  SETTINGS_PAGES.ACCESS_TOKEN,
  SETTINGS_PAGES.SECURITY,

  
  SETTINGS_PAGES.TEAMS,
  SETTINGS_PAGES.GROUPS,
  SETTINGS_PAGES.STATUS,
  SETTINGS_PAGES.PRIORITY,
  SETTINGS_PAGES.TICKET_TYPES,
  SETTINGS_PAGES.CATEGORY,
  SETTINGS_PAGES.RESOLUTIONCATEGORY,
  SETTINGS_PAGES.TAGS,
  SETTINGS_PAGES.TEMPLATES,
  SETTINGS_PAGES.FORMS,
  SETTINGS_PAGES.LIFECYCLE,
  SETTINGS_PAGES.CUSTOM_PROPERTIES,

  SETTINGS_PAGES.SLA,
  SETTINGS_PAGES.AUTOMATION,
  SETTINGS_PAGES.NOTIFICATION_CENTER,
  SETTINGS_PAGES.SERVICE_OFFERING,
  SETTINGS_PAGES.AI_CONFIG,
  SETTINGS_PAGES.TIKIT_CONFIGURATION,
  SETTINGS_PAGES.BOT_CONFIGURATION,
  SETTINGS_PAGES.FEATURE_CONFIGURATION,

  SETTINGS_PAGES.BILLING,
  SETTINGS_PAGES.PREFERENCES
];

export const ARRANGED_SUPER_AGENT_SETTING_KEYS = [
  SETTINGS_PAGES.STATUS,
  SETTINGS_PAGES.PRIORITY,
  SETTINGS_PAGES.TICKET_TYPES,
  SETTINGS_PAGES.CATEGORY,
  SETTINGS_PAGES.RESOLUTIONCATEGORY,
  SETTINGS_PAGES.TAGS,
 
  SETTINGS_PAGES.TEMPLATES,
  SETTINGS_PAGES.FORMS,
  SETTINGS_PAGES.LIFECYCLE,
  SETTINGS_PAGES.CUSTOM_PROPERTIES,
  
  SETTINGS_PAGES.SLA,
  SETTINGS_PAGES.AUTOMATION,
  SETTINGS_PAGES.SERVICE_OFFERING,
  
  SETTINGS_PAGES.PREFERENCES
];

export const ARRANGED_AGENT_SETTING_KEYS = [
  SETTINGS_PAGES.TAGS,
  SETTINGS_PAGES.PREFERENCES
];

export const ARRANGED_KBAGENT_SETTING_KEYS = [
  SETTINGS_PAGES.TEMPLATES,
  SETTINGS_PAGES.FORMS,
  SETTINGS_PAGES.PREFERENCES
];

export const ARRANGED_AGENTKB_SETTING_KEYS = [
  SETTINGS_PAGES.TAGS,
  SETTINGS_PAGES.TEMPLATES,
  SETTINGS_PAGES.FORMS,
  SETTINGS_PAGES.PREFERENCES
];

export const ARRANGED_SETTING_KEYS_TEAMS = [
  SETTINGS_PAGES.ACCESS_TOKEN,
  SETTINGS_PAGES.SECURITY,

  SETTINGS_PAGES.AUTOMATION,
  SETTINGS_PAGES.CATEGORY,
  SETTINGS_PAGES.RESOLUTIONCATEGORY,
  SETTINGS_PAGES.TEAMS,
  SETTINGS_PAGES.GROUPS,
  SETTINGS_PAGES.KNOWLEDGE,
  SETTINGS_PAGES.PRIORITY,
  SETTINGS_PAGES.SLA,
  SETTINGS_PAGES.STATUS,
  SETTINGS_PAGES.TIKIT_CONFIGURATION,
  SETTINGS_PAGES.SERVICE_OFFERING,
  SETTINGS_PAGES.TAGS,
  SETTINGS_PAGES.TEMPLATES,
  SETTINGS_PAGES.FORMS,
  SETTINGS_PAGES.TICKET_TYPES,
  SETTINGS_PAGES.TEMPLATES,
  SETTINGS_PAGES.LIFECYCLE,
  SETTINGS_PAGES.CUSTOM_PROPERTIES,
  SETTINGS_PAGES.USERS,

  SETTINGS_PAGES.BOT_CONFIGURATION
];

export const ARRANGED_END_USER_SETTING_KEYS = [
  SETTINGS_PAGES.PREFERENCES
];

export const ENDPOINT_SECURITY_MAPPINGS = [
  {
    key: SETTINGS_PAGES.SECURITY,
    path: '~/api/ApplicationRoles',
    method: 'GET'
  },
  {
    key: SETTINGS_PAGES.BOT_CONFIGURATION,
    path: "~/api/Get_SystemSetting(TypeName='ServiceDesk.Core.Integrations.Teams.Configuration.TeamsBotConfiguration')",
    method: 'GET'
  },
  {
    key: SETTINGS_PAGES.AI_CONFIG,
    path: "~/api/Get_SystemSetting(TypeName='ServiceDesk.Core.Integrations.Cognitive.AiConfiguration')",
    method: 'GET'
  },
  {
    key: SETTINGS_PAGES.BILLING,
    path: '~/api/GetLicenseSettings',
    method: 'GET'
  },
  {
    key: SETTINGS_PAGES.GROUPS,
    path: '~/api/SupportGroup',
    method: 'POST'
  },
  {
    key: SETTINGS_PAGES.NOTIFICATION_CENTER,
    path: "~/api/Get_SystemSetting(TypeName='ServiceDesk.Common.Integrations.Email.Configuration.EmailConnectorConfiguration')",
    method: 'GET'
  },
  {
    key: SETTINGS_PAGES.SLA,
    path: '~/api/ServiceLevelAgreement',
    method: 'POST'
  },
  {
    key: SETTINGS_PAGES.TEAMS,
    path: '~/api/Team',
    method: 'POST',
  },
  {
    key: SETTINGS_PAGES.TIKIT_CONFIGURATION,
    path: "~/api/Get_SystemSetting(TypeName='ServiceDesk.Core.Configuration.ResolutionNoteConfiguration')",
    method: 'GET'
  },
  {
    key: SETTINGS_PAGES.LIFECYCLE,
    path: '~/api/LifeCycle',
    method: 'POST'
  }
];

export const LOADING_MSG = t('common.loading-msg');

export const SETTINGS_PAGE = {
  DEFAULT_TITLE: t('common.settings-page.default-title'),
  DEFAULT_DESCRIPTION: t('common.settings-page.default-description')
};

export const getModalHeading = (isUpdate: boolean, title: string) =>
  `${isUpdate ? t('common.edit') : t('common.add-new')} ${toTitleCase(title)}`;

export const getModalSubheading = (isUpdate: boolean, title: string) =>
  `${t('common.enter-information')} ${isUpdate ? t('common.small-edit') : t('common.small-add-new')} ${title}`;

export const toastDefault = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: false,
  progress: undefined
} as ToastOptions;

export const getKeyValueDropdownDataModel = (values: any[]): DropdownDataModel[] =>
  values.map((item: any) => ({
    key: item["key"],
    value: item["value"],
    label: item["key"],
    header: item["key"]
  }));

export const AUTOMATION_TRIGGER_TYPES: DropdownDataModel[] = [
  {
    key: 'Added',
    label: t('automation.automation-trigger-types.added'),
    header: t('automation.automation-trigger-types.added')
  },
  {
    key: 'Modified',
    label: t('automation.automation-trigger-types.modified'),
    header: t('automation.automation-trigger-types.modified')
  },
  {
    key: 'AddedModified',
    label: t('automation.automation-trigger-types.added-and-modified'),
    header: t('automation.automation-trigger-types.added-and-modified')
  }
];

  export const AUTOMATION_SCHEDULE_FREQUENCY: DropdownDataModel[] = getKeyValueDropdownDataModel([
    {
      key: t('automation.automation-schedule-frequency.every-hour'),
      value: 'Hour'
    },
    {
      key: t('automation.automation-schedule-frequency.every-day'),
      value: 'Day'
    },
    {
      key: t('automation.automation-schedule-frequency.every-week'),
      value: 'Week'
    },
    {
      key: t('automation.automation-schedule-frequency.every-month'),
      value: 'Month'
    },
    {
      key: t('automation.automation-schedule-frequency.every-year'),
      value: 'Year'
    }
  ]);

export const AUTOMATION_CREATE = {
  WHEN: {
    ENTITY_NAME: t('automation.when.entity-name'),
    TRIGGER_TYPE: t('automation.when.trigger-type'),
    SCHEDULE: t('automation.when.schedule'),
    EVENT: t('automation.when.event'),
    TRIGGER: t('automation.when.trigger')
  },
  IF: {
    TITLE: t('automation.if.title'),
    PLACEHOLDER: t('automation.if.placeholder')
  },
  DO: {
    TITLE: t('automation.do.title'),
    PLACEHOLDER: t('automation.do.placeholder')
  },
};

export enum AutomationOperators {
  Equal = 'Equal',
  NotEqual = 'NotEqual',
  LessThan = 'LessThan',
  LessThanEqualTo = 'LessThanEqualTo',
  GreaterThan = 'GreaterThan',
  GreaterThanEqualTo = 'GreaterThanEqualTo',
  Contains = 'Contains',
  NotContains = 'NotContains',
  EndsWith = 'EndsWith',
  NotEndsWith = 'NotEndsWith',
  StartsWith = 'StartsWith',
  NotStartsWith = 'NotStartsWith',
  IsEmpty = 'IsEmpty',
  IsNotEmpty = 'IsNotEmpty',
  IsNull = 'IsNull',
  IsNotNull = 'IsNotNull',
  AddedByRequester = 'AddedByRequester',
  AddedByAssignee = 'AddedByAssignee',
  ContainsAll = 'ContainsAll',
  NotContainsAll = 'NotContainsAll',
  ContainsAny = 'ContainsAny',
  NotContainsAny = 'NotContainsAny',
  Include = 'Include',
  NotInclude = 'NotInclude',
  Added = 'Added',
  ByAnyone = 'ByAnyone',
  ByAutomation = 'ByAutomation',
  ByRequestor = 'ByRequestor',
  ByAssignee = 'ByAssignee',
  RelateTicket = 'RelateTicket',
  MergeTicket = 'MergeTicket',
  Removed = "Removed",
  Count = "Count",
  AddedbyAgent = "AddedbyAgent",
  AddedbyAffectedUser = "AddedbyAffectedUser",
  AddedbyCollaborator = "AddedbyCollaborator",
  IsPrivate = "IsPrivate",
  IsMentioned = "IsMentioned",
  Updated = "Updated"
}

export enum AutomationEvaluationTypes {
  None = 'None',
  Changed = 'Changed',
  Added = 'Added',
  Removed = 'Removed',
  ChangedFrom = 'ChangedFrom',
  ChangedTo = 'ChangedTo',
  ChangedFromTo = 'ChangedFromTo',
  Applied = 'Applied',
  Transitioned = 'Transitioned'
}



export const AUTOMATION_DATESPECIFIC_OPERATORS: any[] = [
  {
    key: t('automation.automation-datespecific-operators.earlier-than'),
    value: AutomationOperators.GreaterThan
  },
  {
    key: t('automation.automation-datespecific-operators.later-than'),
    value: AutomationOperators.LessThan
  },
  {
    key: t('automation.automation-datespecific-operators.earlier-than-or-equal-to'),
    value: AutomationOperators.GreaterThanEqualTo
  },
  {
    key: t('automation.automation-datespecific-operators.later-than-or-equal-to'),
    value: AutomationOperators.LessThanEqualTo
  },
  {
    key: t('automation.automation-datespecific-operators.is-null'),
    value: AutomationOperators.IsNull
  },
  {
    key: t('automation.automation-datespecific-operators.is-not-null'),
    value: AutomationOperators.IsNotNull
  }
]

const getDropdownDataModel = (values: string[], prefix: string): DropdownDataModel[] => {
  return values.map((value: string) => { 
    const trans = t(`${prefix}.${value.toLowerCase()}`);
    return {    
      key: trans,
      value: value,
      label: trans,
      header: trans
    }
  });
}
  

export const AUTOMATION_OPERATORS = {
  basic: getDropdownDataModel([
    AutomationOperators.Equal,
    AutomationOperators.NotEqual,
    AutomationOperators.IsNull,
    AutomationOperators.IsNotNull
  ], 'automation.automation-operators'),
  number: getDropdownDataModel([
    AutomationOperators.Equal,
    AutomationOperators.NotEqual,
    AutomationOperators.GreaterThan,
    AutomationOperators.GreaterThanEqualTo,
    AutomationOperators.LessThan,
    AutomationOperators.LessThanEqualTo,
    AutomationOperators.IsNull,
    AutomationOperators.IsNotNull
  ],'automation.automation-operators'),
  date: getKeyValueDropdownDataModel(AUTOMATION_DATESPECIFIC_OPERATORS),
  comment: getDropdownDataModel([
    AutomationOperators.Contains,
    AutomationOperators.NotContains,
    AutomationOperators.IsPrivate,
    AutomationOperators.Added,
    AutomationOperators.AddedByRequester,
    AutomationOperators.AddedByAssignee,
    AutomationOperators.AddedbyAgent,
    AutomationOperators.AddedbyAffectedUser,
    AutomationOperators.AddedbyCollaborator,
    AutomationOperators.IsMentioned
  ],'automation.automation-operators'),
  tag: getDropdownDataModel([//approvers
    AutomationOperators.Equal,
    AutomationOperators.NotEqual,
    AutomationOperators.Contains,
    AutomationOperators.NotContains,
    AutomationOperators.Include,
    AutomationOperators.NotInclude
  ],'automation.automation-operators'),
  approver: getDropdownDataModel([
    AutomationOperators.Equal,
    AutomationOperators.NotEqual,
    AutomationOperators.Include,
    AutomationOperators.NotInclude
  ],'automation.automation-operators'),
  request: getDropdownDataModel([
    AutomationOperators.Equal,
    AutomationOperators.NotEqual,
    AutomationOperators.Contains,
    AutomationOperators.NotContains,
    AutomationOperators.EndsWith,
    AutomationOperators.NotEndsWith,
    AutomationOperators.StartsWith,
    AutomationOperators.NotStartsWith,
    AutomationOperators.IsEmpty,
    AutomationOperators.IsNotEmpty,
    AutomationOperators.IsNull,
    AutomationOperators.IsNotNull
  ],'automation.automation-operators'),
  stringNoEmpty: getDropdownDataModel([
    AutomationOperators.Equal,
    AutomationOperators.NotEqual,
    AutomationOperators.Contains,
    AutomationOperators.NotContains,
    AutomationOperators.EndsWith,
    AutomationOperators.NotEndsWith,
    AutomationOperators.StartsWith,
    AutomationOperators.NotStartsWith
  ],'automation.automation-operators'),
  equal_notequal: getDropdownDataModel([
    AutomationOperators.Equal,
    AutomationOperators.NotEqual
  ],'automation.automation-operators'),
  evaluationType: getDropdownDataModel([
    AutomationEvaluationTypes.None,
    AutomationEvaluationTypes.Changed,
    AutomationEvaluationTypes.ChangedFrom,
    AutomationEvaluationTypes.ChangedTo,
    AutomationEvaluationTypes.ChangedFromTo,
  ],'automation.automation-operators'),
  templateEvaluationType: getDropdownDataModel([
    AutomationEvaluationTypes.None,
    AutomationEvaluationTypes.Applied,
    AutomationEvaluationTypes.Changed,
    AutomationEvaluationTypes.ChangedFrom,
    AutomationEvaluationTypes.ChangedTo,
    AutomationEvaluationTypes.ChangedFromTo,
  ],'automation.automation-operators'),
  noneEvaluationType: getDropdownDataModel([
    AutomationEvaluationTypes.None
  ],'automation.automation-operators'),
  // Agent Time carries its whole meaning in the operator - there is nothing to compare
  // against, so all three disable the Value field.
  // Its own namespace purely to relabel one operator: the UI deletes time, so this list
  // must read Deleted, but the stored value stays Removed. That value shares an ordinal
  // with the collaborator condition, where "removed" is the right word, so renaming the
  // operator itself would relabel a shipped feature and repoint saved rules.
  agentTime: getDropdownDataModel([
    AutomationOperators.Added,
    AutomationOperators.Updated,
    AutomationOperators.Removed
  ],'automation.agent-time-operators'),
  templateFull: getDropdownDataModel([
    AutomationOperators.Equal,
    AutomationOperators.NotEqual,
    AutomationOperators.Contains,
    AutomationOperators.NotContains,
    AutomationOperators.EndsWith,
    AutomationOperators.NotEndsWith,
    AutomationOperators.StartsWith,
    AutomationOperators.NotStartsWith
  ],'automation.automation-operators'),
  templateChanged: getDropdownDataModel([
    AutomationOperators.ByAnyone,
    AutomationOperators.ByAutomation,
    AutomationOperators.ByRequestor,
    AutomationOperators.ByAssignee
  ],'automation.automation-operators'),
  templateChangedNoneBy: getDropdownDataModel([
    AutomationOperators.Equal,
    AutomationOperators.NotEqual,
    AutomationOperators.IsNull,
    AutomationOperators.IsNotNull
  ],'automation.automation-operators'),
  relatedTickets: getDropdownDataModel([
    AutomationOperators.RelateTicket,
    AutomationOperators.MergeTicket
  ],'automation.automation-operators'),
  requester: getDropdownDataModel([
    AutomationOperators.Equal,
    AutomationOperators.NotEqual,
    AutomationOperators.Contains,
    AutomationOperators.NotContains,
    AutomationOperators.IsNull,
    AutomationOperators.IsNotNull
  ], 'automation.automation-operators.requester'),
  AUC: getDropdownDataModel([
    AutomationOperators.Equal,
    AutomationOperators.NotEqual,
    AutomationOperators.Include,
    AutomationOperators.NotInclude,
    AutomationOperators.Added,
    AutomationOperators.Removed
  ],'automation.automation-operators'),
  AUCCount: getDropdownDataModel([
    AutomationOperators.Equal,
    AutomationOperators.NotEqual,
    AutomationOperators.GreaterThan,
    AutomationOperators.GreaterThanEqualTo,
    AutomationOperators.LessThan,
    AutomationOperators.LessThanEqualTo
  ],'automation.automation-operators'),
  activePhaseEvaluationType: getDropdownDataModel([
    AutomationEvaluationTypes.None,
    AutomationEvaluationTypes.Transitioned
  ],'automation.automation-operators'),
  
  
};


export const AUTOMATION_PROPERTIES = {
  requester: t('automation.automation-properties.requester'),
  title: t('automation.automation-properties.title'),
  closed: t('automation.automation-properties.closed'),
  duedate: t('automation.automation-properties.duedate'),
  resolutiondate: t('automation.automation-properties.resolutiondate'),
  assignee: t('automation.automation-properties.assignee'),
  supportgroup: t('automation.automation-properties.supportgroup'),
  tickettype: t('automation.automation-properties.tickettype'),
  category: t('automation.automation-properties.category'),
  priority: t('automation.automation-properties.priority'),
  status: t('automation.automation-properties.status'),
  comments: t('automation.automation-properties.comments'),
  agenttime: t('automation.automation-properties.agenttime'),
  modifieddate: t('automation.automation-properties.modifieddate'),
  createddate: t('automation.automation-properties.createddate'),
  team: t('automation.automation-properties.team'),
  source: t('automation.automation-properties.source'),
  tags: t('automation.automation-properties.tags'),
  affectedusers: t('automation.automation-properties.affected-users'),
  ticketcollaborators: t('automation.automation-properties.collaborators'),
  servicelevelagreement: t('sla.name'),
  slastate: t('sla.state'),
  approvaltitle: t('automation.automation-properties.approval-title'),
  approvalstate: t('sla.state'),
  template: t('automation.automation-properties.template-pplied'),
  relatedtickets: t('automation.automation-properties.relatedtickets'),
  additionaldetails: t('automation.automation-properties.additionaldetails'),
  isrequiredbyall: t('automation.automation-properties.isrequiredbyall'),
  approvers: t('automation.automation-properties.approvers'),
  "ticketlifecyclephase.name": t('automation.automation-properties.ticketlifecyclephase.name'),
  "phases.name": t('automation.automation-properties.phases.name'),
  "activephase": t('automation.automation-properties.activephase'),
  lifecycle: t('automation.automation-properties.lifecycle'),
  affecteduserscount: t('automation.automation-properties.affecteduserscount'),
  collaboratorscount: t('automation.automation-properties.collaboratorscount'),
  taskcollaborators: t('automation.automation-properties.collaborators'),
  resolutioncategory: t('resolution-note.resolution-category'),
  note: t('resolution-note.resolution-note'),
  internalnote: t('resolution-note.resolution-note-internal'),
  draftkb: t('resolution-note.draft-kb'),
  resolution_resolutioncategory: t('resolution-note.resolution-category'),
  resolution_note: t('resolution-note.resolution-note'),
  resolution_internalnote: t('resolution-note.resolution-note-internal'),
  resolution_draftkb: t('resolution-note.draft-kb')
};

export const AUTOMATION_ACTION_TYPE = [
  { key: 'create', label: t('automation.automation-action.type-create'), header: t('automation.automation-action-type.create') },
  { key: 'update', label: t('automation.automation-action.type-update'), header: t('automation.automation-action-type.update') },
  { key: 'notification', label: t('automation.automation-action-type.notification'), header: t('automation.automation-action-type.notification') },
  { key: 'applytemplate', label: t('automation.automation-action-type.applytemplate'), header: t('automation.automation-action-type.applytemplate') },
  { key: 'sendcustomform', label: t('automation.automation-action-type.sendcustomform'), header: t('automation.automation-action-type.sendcustomform') },
];
/**
 * Sentinel Value for an automation's "Do: Update Ticket - Assignee" meaning "the next member
 * of the ticket's support group, in rotation". Matched verbatim by the backend
 * (Constants.RoundRobinAssigneeValue) - the two must stay in step.
 */
export const ROUND_ROBIN_ASSIGNEE_VALUE = 'RoundRobin';

export const AUTOMATION_CLOSE_VALUE = [
  { key: 'true', label: 'True', header: 'True', Id: 1 },
  { key: 'false', label: 'False', header: 'False', Id: 2 }
];

export const FILTERS_STRINGS = {
  ARCHIVE_FALSE: '?$filter=(IsArchived%20eq%20false)',
  TICKET_SLA_FILTER: '?$orderby=CreatedDate desc&$select=CreatedDate,ModifiedDate,TicketId,SlaStateId&$expand=SlaState,ServiceLevelAgreement($select=Name,IsActive,CreatedDate;$expand=SlaCriterias($select=Id,TimeDigitPart,TimeUnitPart,SlaActionTypeId,CreatedDate))',
  // Leaner shape for paginated views: no nested ServiceLevelAgreement/SlaCriterias expand, definitions are joined client-side from SlaDefinitionCache
  TICKET_SLA_FILTER_LEAN: '?$orderby=CreatedDate desc&$select=CreatedDate,ModifiedDate,TicketId,SlaStateId,ServiceLevelAgreementId&$expand=SlaState($select=Name)',
  TICKET_GROUPS: '?$select=Id,Name,TeamsAadObjectId,TeamsChannelId&$expand=Members&$filter=IsDeleted%20eq%20false%20and%20IsArchived%20eq%20false&$orderby=Name',
  FILTERS_URL_PARAMS: '?$filter=IsDeleted%20eq%20false%20and%20IsArchived%20eq%20false',
  TICKET_DETAILS: '?$expand=Tags,Template($select=Name,NoCustomForm;$expand=TemplateForms($expand=Form)),AffectedUsers($select=PlatformUserId),TicketCollaborators($select=PlatformUserId),CustomForms,CustomFormTemplate($expand=TemplateForms($expand=Form))',
  TICKET_SLA_EXPAND: '?$expand=TicketSlas($orderby=CreatedDate desc;$select=CreatedDate,ModifiedDate;$expand=SlaState,ServiceLevelAgreement($select=Name,IsActive,CreatedDate;$expand=SlaCriterias($select=Id,TimeDigitPart,TimeUnitPart,SlaActionTypeId,CreatedDate)))',
  TICKET_LIFECYCLE_EXPAND: '?$expand=TicketLifecycle($expand=Status,Lifecycle($select=Title),Phases($orderby=Order))',
  TICKET_GROUP_CHAT_EXPAND: '?$expand=GroupChat($select=ConversationId,Id;$expand=Members($select=Id,AadObjectId,UserName,FullName))',
  FILTERS_URL_PARAMS_EXCLUDE_DEFAULT: '?$filter=IsDeleted%20eq%20false%20and%20IsArchived%20eq%20false%20and%20IsDefault%20eq%20false',
  TICKET_TEAMS: '?$select=Id,FriendlyName,TeamsAadObjectId,TeamsChannelId,IsDefault,EmailAddress&$filter=IsDeleted%20eq%20false&$orderby=FriendlyName',
  DELETE_FALSE: '?$filter=(IsDeleted%20eq%20false)&$orderby=Name asc',
  LIFECYCLE_PARAMS: '?$filter=(IsDeleted%20eq%20false)&$orderby=Title asc',
  IS_DEFAULT: '?$filter=IsDefault eq true',
  CUSTOM_PROPERTY_LIST: '$expand=CustomPropertyListConfiguration,CustomPropertyListItems'
}

  export const AUTOMATION_RELATIVE_DATE = {
    'today-0': t('automation.automation-relative-date.today-0'),
    'yesterday-0': t('automation.automation-relative-date.yesterday-0'),
    'tomorrow-0': t('automation.automation-relative-date.tomorrow-0'),
    'firstdayofmonth-0': t('automation.automation-relative-date.firstdayofmonth-0'),
    'firstdayofquarter-0': t('automation.automation-relative-date.firstdayofquarter-0'),
    'firstdayofyear-0': t('automation.automation-relative-date.firstdayofyear-0'),
    'lastdayofmonth-0': t('automation.automation-relative-date.lastdayofmonth-0'),
    'lastdayofquarter-0': t('automation.automation-relative-date.lastdayofquarter-0'),
    'lastdayofyear-0': t('automation.automation-relative-date.lastdayofyear-0'),
    'minutesago-': t('automation.automation-relative-date.minutesago-'),
    'hoursago-': t('automation.automation-relative-date.hoursago-'),
    'daysago-': t('automation.automation-relative-date.daysago-'),
    'monthsago-': t('automation.automation-relative-date.monthsago-'),
    'yearsago-': t('automation.automation-relative-date.yearsago-'),
    'minutesfromnow-': t('automation.automation-relative-date.minutesfromnow-'),
    'hoursfromnow-': t('automation.automation-relative-date.hoursfromnow-'),
    'daysfromnow-': t('automation.automation-relative-date.daysfromnow-'),
    'monthsfromnow-': t('automation.automation-relative-date.monthsfromnow-'),
    'yearsfromnow-': t('automation.automation-relative-date.yearsfromnow-')
  };

export const getDropdownDateModel = (): DropdownDataModel[] =>
  Object.keys(AUTOMATION_RELATIVE_DATE).map((key) => ({
    key: key,
    label: AUTOMATION_RELATIVE_DATE[key],
    header: AUTOMATION_RELATIVE_DATE[key]
  }));

export const DEFAULT_AUTOMATION_INFO_DATA: AutomationInfoData = {
  title: '',
  description: '',
  enabled: false
};

export const DEFAULT_AUTOMATION_WHEN_DATA: AutomationWhenData = {
  entityName: ENTITY_TYPE.Ticket,
  onEvent: true,
  triggerType: "Added",
  onSchedule: false,
  scheduleFrequency: "Hour"
};

export const DEFAULT_AUTOMATION_DO_DATA: AutomationDoData = {
  actionName: '',
  actionType: 'Update' //t('automation.default-automation-do-data.update')
};

export const DEFAULT_AUTOMATION_FILTER: AutomationFilter = {
  key: uniqueId('id'),
  Id: 0,
  evaluationType:'',
  eventActionType:'',
  property: '',
  operator: '',
  operator2: '',
  value: '',
  value2: '',
  GroupId: 0
};

export const DEFAULT_AUTOMATION_PROPERTY: AutomationDoTicketInfo = {
  key: uniqueId('id'),
  Id: 0,
  Property: '',
  Value: '',
  ActionId: 0
};

export const DEFAULT_AUTOMATION_GROUP: AutomationGroup = {
  key: '1',
  id: 0,
  loading: false,
  disabled:false,
  ruleName: '',
  type: 'And',
  arrowHeight: 50,
  filters: [DEFAULT_AUTOMATION_FILTER],
  ParentGroupId: null,
  RuleEntitySectionId: 0
};

export const AUTOMATION_CHILD_GROUP: AutomationChildrenGroup = {
  key: uniqueId('id'),
  id: 0,
  type: AND,
  ParentGroupId: null,
  arrowHeight: 50,
  filters: [DEFAULT_AUTOMATION_FILTER],
  RuleEntitySectionId: null
};

export const DEFAULT_AUTOMATION_EDIT_DATA: AutomationEditData = {
  Id: 0,
  TriggerId: 0,
  OrderOneStep: {
    Id: 0,
    StepId: 0
  },
  OrderTwoStep: {
    Id: 0,
    StepId: 0
  }
};

export const PRIMARY_COLOR_STYLE = { color: '#6264a7' };

export enum TriggerState {
  Added = 4,
  Deleted = 8,
  Modified = 16,
  AddedModified = 101,
  Scheduled = 0
}

export enum ScheduleFrequency {
  Minute,
  Hour,
  Day,
  Week,
  Month,
  Year
}

export enum ActionType {
  UPDATE = 2,
  CREATE = 3,
  NOTIFICATION = 4,
  APPLYTEMPLATE = 5,
  SENDCUSTOMFORM = 6
}

export enum RuleGroupType {
  And,
  Or
}

export enum RuleCriteriaOperator {
  Equal,
  NotEqual,
  LessThan,
  LessThanEqualTo,
  GreaterThan,
  GreaterThanEqualTo,
  Contains,
  NotContains,
  EndsWith,
  NotEndsWith,
  StartsWith,
  NotStartsWith,
  IsEmpty,
  IsNotEmpty,
  IsNull,
  IsNotNull,
  AddedByRequester,
  AddedByAssignee,
  ContainsAll,
  NotContainsAll,
  ContainsAny,
  NotContainsAny,
  Include,
  NotInclude,
  Added,
  ByAnyone,
  ByAutomation,
  ByRequestor,
  ByAssignee,
  RelateTicket,
  MergeTicket,
  Removed,
  Count,
  AddedbyAgent,
  AddedbyAffectedUser,
  AddedbyCollaborator,
  IsPrivate,
  IsMentioned,
  // Append only, and must stay at the same ordinal as RuleCriteriaOperator in the
  // backend's ServiceDesk.Common/Utility/Constants.cs - these numbers are what get
  // stored against every saved automation rule.
  Updated
}

export enum RuleCriteriaEventActionType {
  Default,
  Changed,
  ChangedFrom,
  ChangedTo,
  ChangedFromTo,
  Added,
  Removed,
  Applied,
  Transitioned
}

export const AUTOMATION_LABELS = {
  NOTIFICATION: "Notification",
  TEAMS_NOTIFICATION: t('automation.automation-labels.teams-notification'),
  EMAIL_NOTIFICATION: t('automation.automation-labels.email-notification'),
  REQUESTER: t('automation.automation-labels.requester'),
  CHANNEL: t('automation.automation-labels.channel'),
  ASSIGNEE: t('automation.automation-labels.assignee'),
  MESSAGE: t('automation.automation-labels.message'),
  DELIVERY_OPTIONS: t('automation.automation-labels.delivery-options'),
  FEATURE_RESTRICTED: t('automation.automation-labels.feature-restricted'),
  GROUP: t('automation.automation-labels.group'),
  TEAM: t('automation.automation-labels.team'),
  Approvers: t('automation.automation-labels.approvers'),
  TaskAssignee: t('automation.automation-labels.task-assignee'),
  NotifySelectedUsers: t('automation.automation-labels.notify-selected-users'),
  NotifySelectUsers: t('automation.automation-labels.notify-select-users'),
  ExcludeFooter: t('automation.automation-labels.exclude-footer'),
  SendCustomForm: t("ticket-details.apply-template.template-selection.send-form"),
  Select_template: t("ticket-details.apply-template.template-selection.select-template"),
  current_selected_template: t("ticket-details.apply-template.template-selection.defaul-template"),
  Template: t("ticket-details.apply-template.template-selection.template"),
  Collaborator: t("automation.automation-labels.collaborator"),
  AffectedUser: t("automation.automation-labels.affected-user"),
  ChooseCardHeader: t("automation.automation-labels.choose-card-hedaer"),
  ChooseCardDescription: t("automation.automation-labels.choose-card-discription"),
  ChooseCardCopy: t("automation.automation-labels.choose-card-copy"),
  NotificationRecipients: t("automation.automation-labels.notification-recipients"),
  Mentioned: t("automation.automation-labels.mentioned-users"),
  TaskCollaborators: t("automation.automation-labels.task-collaborators"),
  TaskGroup: t("automation.automation-labels.task-group"),
  TaskTeam: t("automation.automation-labels.task-team"),
  SendCustomFormAssignee: t("ticket-details.apply-template.template-selection.send-form-assignee"),
  SendCustomFormSelectedUser: t("ticket-details.apply-template.template-selection.send-form-selecteduser"),
}



export const TEMPLATE = {
  TEMPLATE: t('template.template'),
  TEMPLATE_HEADER: t('template.template-header'),
  TEMPLATE_PROPERTIES: t('template.template-properties'),
  TEMPLATE_PROPS_DESC: t('template.template-props-desc'),
  CREATE_FROM_SCRATCH: t('template.create-from-scratch'),
  CREATE_FROM_DEFAULT: t('template.create-from-default'),
  START_FROM_SCRATCH: t('template.start-from-scratch'),
  START_FROM_DEFAULT: t('template.start-from-default'),
  CUSTOM_FORM: t("ticket-details.apply-template.template-selection.custom-form"),
  CREATE_CUSTOM_FORM: t('template.create-custom-form'),
  UPDATE_CUSTOM_FORM: t('template.update-custom-form'),
  CREATE_NEW_TEMPLATE: t('template.create-new-template'),
  CREATE_CUSTOM_FORM_DESCRIPTION:
  t('template.create-custom-form-description'),
  UPDATE_CUSTOM_FORM_DESCRIPTION:
  t('template.update-custom-form-description'),
  DEFAULT_CUSTOM_FORM_DESCRIPTION:
  t('template.default-custom-form-description'),
  CREATE_NEW_TEMPLATE_DESCRIPTION:
  t('template.create-new-template-description'),
  CHOOSE_CUSTOM_FORM: t('template.choose-custom-form'),
  CHOOSE_CUSTOM_FORM_UPDATE: t('template.choose-custom-form-update'),
  CHOOSE_TEMPLATE: t('template.choose-template'),
  DEFAULT_FORMS: t('template.default-forms'),
  DEFAULT_TEMPLATES: t('template.default-templates'),
  DESIGNER_CUSTOM_BUTTON: t('template.designer-custom-button'),
  UPDATE_TICKET_DATA: t('template.update-ticket-data'),
  UPDATE_TICKET_DATA_DESCRIPTION: t("ticket-details.apply-template.template-selection.update-ticket-data-description"),
  FINISH_TICKET_DATA: t('template.finish-ticket-data'),
  FINISH_TICKET_DATA_DESCRIPTION:
  t('template.finish-ticket-data-description'),
  SEND_FORM: t("ticket-details.apply-template.template-selection.send-form"),
  SEND_FORM_ASSIGNEE: t("ticket-details.apply-template.template-selection.send-form-assignee"),
  SEND_FORM_AFFECTEDUSER: t("ticket-details.apply-template.template-selection.send-form-affecteduser"),
  SEND_FORM_COLLABORATOR: t("ticket-details.apply-template.template-selection.send-form-collaborator"),
  SEND_FORM_SELECTEDUSER: t("ticket-details.apply-template.template-selection.send-form-selecteduser"),
  ANSWER_FORM: t("ticket-details.apply-template.template-selection.answer-form"),
  ANSWER_FORM_APPLY: t("ticket-details.apply-template.template-selection.answer-form"),
  ANSWER_FORM_CREATE: t("ticket-details.apply-template.template-selection.answer-form"),
  CHOOSE_FINAL_ACTION: t("ticket-details.apply-template.template-selection.choose-final-action"),
  EXISTING_TEMPLATES: t("ticket-details.apply-template.template-selection.exisiting-templates"),
  SELECT_TEMPLATE: t("ticket-details.apply-template.template-selection.select-template"),
  SELECT_TEMPLATE_DESCRIPTION: t("ticket-details.apply-template.template-selection.select-template-description"),
  UNSET_VALUE: t("ticket-details.apply-template.template-selection.unset-value"),
  UNCHANGE_VALUE: t('template.unchange-value'),
  UNASSIGNED: t("ticket-details.apply-template.template-selection.unassigned"),
  ERROR_NAME_REQUIRED: t('template.error-name-required'),
  ERROR_NAME_EXIST: t('template.error-name-exist'),
  TEMPLATE_INPUT_PLACEHOLDER: t("ticket-details.apply-template.template-selection.input-placeholder"),
  EMPTY_TEMPLATE_SELECTION: t("ticket-details.apply-template.template-selection.empty-template-selection"),
  APPLY: t("ticket-details.apply-template.template-selection.apply"),
  TICKET_PROPERTIES: t("ticket-details.apply-template.template-selection.ticket-properties"),
  ASSIGN_PRESET_PROPERTY: t("ticket-details.apply-template.template-selection.assign-preset-property"),
  NO_PROPERTY_TO_CHANGE: t("ticket-details.apply-template.template-selection.no-property-to-change"),
  SEND: t("ticket-details.apply-template.template-selection.send"),
  ERROR_NO_CARD_SELECTED: 'Select a predefined form to continue.',
  TEMPLATE_FORM: 'Forms',
  TEMPLATE_SHARING: t('scoping.header'),
};

export const TICKET_DETAIL = {
  ASSIGNEE: t('ticket-details.ticket-details-card.ticket-details-info.assignee'),
  REQUESTER: t('ticket-details.ticket-details-card.ticket-details-info.requester'),
  PRIORITY: t('ticket-details.ticket-details-card.ticket-details-info.priority'),
  CATEGORY: t('ticket-details.ticket-details-card.ticket-details-info.category'),
  TEAM: t('ticket-details.ticket-details-card.ticket-details-info.team'),
  GROUP: t('ticket-details.ticket-details-card.ticket-details-info.group'),
  TAGS: t('ticket-details.ticket-details-card.ticket-details-info.tags'),
  DUE_DATE: t('ticket-details.ticket-details-card.ticket-details-info.due-date'),
  TEMPLATE: t('ticket-details.ticket-details-card.ticket-details-info.template'),
  MODIFIED: t('ticket-details.ticket-details-card.ticket-details-info.modified'),
  TICKET_TYPE: t('ticket-details.ticket-details-card.ticket-details-info.type'),
  SLAS: t('ticket-details.ticket-details-card.ticket-details-info.slas'),
  // Reuses the view column's string so the header and the column can never drift apart.
  TOTAL_AGENT_TIME: t('ticket.ticket-list.total-agent-time')
};

export const ADMINISTRATORS = 'Administrators';
export const ANALYSTS = 'Analysts';
export const AGENTS = 'Agents';
export const KNOWLEDGEAGENT = 'KnowledgeAgents';
export const KNOWLEDGEREADER = 'KnowledgeReader';
export const COUNTRIES: Array<DropdownItemProps> = [
  {
    header: 'Afghanistan',
    accessibilityItemProps: { accessibilityItemProps: { value: 'AF' } }
  },
  { header: 'Åland Islands', accessibilityItemProps: { value: 'AX' } },
  { header: 'Albania', accessibilityItemProps: { value: 'AL' } },
  { header: 'Algeria', accessibilityItemProps: { value: 'DZ' } },
  { header: 'American Samoa', accessibilityItemProps: { value: 'AS' } },
  { header: 'Andorra', accessibilityItemProps: { value: 'AD' } },
  { header: 'Angola', accessibilityItemProps: { value: 'AO' } },
  { header: 'Anguilla', accessibilityItemProps: { value: 'AI' } },
  { header: 'Antarctica', accessibilityItemProps: { value: 'AQ' } },
  { header: 'Antigua and Barbuda', accessibilityItemProps: { value: 'AG' } },
  { header: 'Argentina', accessibilityItemProps: { value: 'AR' } },
  { header: 'Armenia', accessibilityItemProps: { value: 'AM' } },
  { header: 'Aruba', accessibilityItemProps: { value: 'AW' } },
  { header: 'Australia', accessibilityItemProps: { value: 'AU' } },
  { header: 'Austria', accessibilityItemProps: { value: 'AT' } },
  { header: 'Azerbaijan', accessibilityItemProps: { value: 'AZ' } },
  { header: 'Bahamas', accessibilityItemProps: { value: 'BS' } },
  { header: 'Bahrain', accessibilityItemProps: { value: 'BH' } },
  { header: 'Bangladesh', accessibilityItemProps: { value: 'BD' } },
  { header: 'Barbados', accessibilityItemProps: { value: 'BB' } },
  { header: 'Belarus', accessibilityItemProps: { value: 'BY' } },
  { header: 'Belgium', accessibilityItemProps: { value: 'BE' } },
  { header: 'Belize', accessibilityItemProps: { value: 'BZ' } },
  { header: 'Benin', accessibilityItemProps: { value: 'BJ' } },
  { header: 'Bermuda', accessibilityItemProps: { value: 'BM' } },
  { header: 'Bhutan', accessibilityItemProps: { value: 'BT' } },
  { header: 'Bolivia', accessibilityItemProps: { value: 'BO' } },
  { header: 'Bosnia and Herzegovina', accessibilityItemProps: { value: 'BA' } },
  { header: 'Botswana', accessibilityItemProps: { value: 'BW' } },
  { header: 'Bouvet Island', accessibilityItemProps: { value: 'BV' } },
  { header: 'Brazil', accessibilityItemProps: { value: 'BR' } },
  {
    header: 'British Indian Ocean Territory',
    accessibilityItemProps: { value: 'IO' }
  },
  { header: 'Brunei Darussalam', accessibilityItemProps: { value: 'BN' } },
  { header: 'Bulgaria', accessibilityItemProps: { value: 'BG' } },
  { header: 'Burkina Faso', accessibilityItemProps: { value: 'BF' } },
  { header: 'Burundi', accessibilityItemProps: { value: 'BI' } },
  { header: 'Cambodia', accessibilityItemProps: { value: 'KH' } },
  { header: 'Cameroon', accessibilityItemProps: { value: 'CM' } },
  { header: 'Canada', accessibilityItemProps: { value: 'CA' } },
  { header: 'Cape Verde', accessibilityItemProps: { value: 'CV' } },
  { header: 'Cayman Islands', accessibilityItemProps: { value: 'KY' } },
  {
    header: 'Central African Republic',
    accessibilityItemProps: { value: 'CF' }
  },
  { header: 'Chad', accessibilityItemProps: { value: 'TD' } },
  { header: 'Chile', accessibilityItemProps: { value: 'CL' } },
  { header: 'China', accessibilityItemProps: { value: 'CN' } },
  { header: 'Christmas Island', accessibilityItemProps: { value: 'CX' } },
  {
    header: 'Cocos (Keeling) Islands',
    accessibilityItemProps: { value: 'CC' }
  },
  { header: 'Colombia', accessibilityItemProps: { value: 'CO' } },
  { header: 'Comoros', accessibilityItemProps: { value: 'KM' } },
  { header: 'Congo', accessibilityItemProps: { value: 'CG' } },
  {
    header: 'Congo, The Democratic Republic of the',
    accessibilityItemProps: { value: 'CD' }
  },
  { header: 'Cook Islands', accessibilityItemProps: { value: 'CK' } },
  { header: 'Costa Rica', accessibilityItemProps: { value: 'CR' } },
  { header: "Cote D'Ivoire", accessibilityItemProps: { value: 'CI' } },
  { header: 'Croatia', accessibilityItemProps: { value: 'HR' } },
  { header: 'Cuba', accessibilityItemProps: { value: 'CU' } },
  { header: 'Cyprus', accessibilityItemProps: { value: 'CY' } },
  { header: 'Czech Republic', accessibilityItemProps: { value: 'CZ' } },
  { header: 'Denmark', accessibilityItemProps: { value: 'DK' } },
  { header: 'Djibouti', accessibilityItemProps: { value: 'DJ' } },
  { header: 'Dominica', accessibilityItemProps: { value: 'DM' } },
  { header: 'Dominican Republic', accessibilityItemProps: { value: 'DO' } },
  { header: 'Ecuador', accessibilityItemProps: { value: 'EC' } },
  { header: 'Egypt', accessibilityItemProps: { value: 'EG' } },
  { header: 'El Salvador', accessibilityItemProps: { value: 'SV' } },
  { header: 'Equatorial Guinea', accessibilityItemProps: { value: 'GQ' } },
  { header: 'Eritrea', accessibilityItemProps: { value: 'ER' } },
  { header: 'Estonia', accessibilityItemProps: { value: 'EE' } },
  { header: 'Ethiopia', accessibilityItemProps: { value: 'ET' } },
  {
    header: 'Falkland Islands (Malvinas)',
    accessibilityItemProps: { value: 'FK' }
  },
  { header: 'Faroe Islands', accessibilityItemProps: { value: 'FO' } },
  { header: 'Fiji', accessibilityItemProps: { value: 'FJ' } },
  { header: 'Finland', accessibilityItemProps: { value: 'FI' } },
  { header: 'France', accessibilityItemProps: { value: 'FR' } },
  { header: 'French Guiana', accessibilityItemProps: { value: 'GF' } },
  { header: 'French Polynesia', accessibilityItemProps: { value: 'PF' } },
  {
    header: 'French Southern Territories',
    accessibilityItemProps: { value: 'TF' }
  },
  { header: 'Gabon', accessibilityItemProps: { value: 'GA' } },
  { header: 'Gambia', accessibilityItemProps: { value: 'GM' } },
  { header: 'Georgia', accessibilityItemProps: { value: 'GE' } },
  { header: 'Germany', accessibilityItemProps: { value: 'DE' } },
  { header: 'Ghana', accessibilityItemProps: { value: 'GH' } },
  { header: 'Gibraltar', accessibilityItemProps: { value: 'GI' } },
  { header: 'Greece', accessibilityItemProps: { value: 'GR' } },
  { header: 'Greenland', accessibilityItemProps: { value: 'GL' } },
  { header: 'Grenada', accessibilityItemProps: { value: 'GD' } },
  { header: 'Guadeloupe', accessibilityItemProps: { value: 'GP' } },
  { header: 'Guam', accessibilityItemProps: { value: 'GU' } },
  { header: 'Guatemala', accessibilityItemProps: { value: 'GT' } },
  { header: 'Guernsey', accessibilityItemProps: { value: 'GG' } },
  { header: 'Guinea', accessibilityItemProps: { value: 'GN' } },
  { header: 'Guinea-Bissau', accessibilityItemProps: { value: 'GW' } },
  { header: 'Guyana', accessibilityItemProps: { value: 'GY' } },
  { header: 'Haiti', accessibilityItemProps: { value: 'HT' } },
  {
    header: 'Heard Island and Mcdonald Islands',
    accessibilityItemProps: { value: 'HM' }
  },
  {
    header: 'Holy See (Vatican City State)',
    accessibilityItemProps: { value: 'VA' }
  },
  { header: 'Honduras', accessibilityItemProps: { value: 'HN' } },
  { header: 'Hong Kong', accessibilityItemProps: { value: 'HK' } },
  { header: 'Hungary', accessibilityItemProps: { value: 'HU' } },
  { header: 'Iceland', accessibilityItemProps: { value: 'IS' } },
  { header: 'India', accessibilityItemProps: { value: 'IN' } },
  { header: 'Indonesia', accessibilityItemProps: { value: 'ID' } },
  {
    header: 'Iran, Islamic Republic Of',
    accessibilityItemProps: { value: 'IR' }
  },
  { header: 'Iraq', accessibilityItemProps: { value: 'IQ' } },
  { header: 'Ireland', accessibilityItemProps: { value: 'IE' } },
  { header: 'Isle of Man', accessibilityItemProps: { value: 'IM' } },
  { header: 'Israel', accessibilityItemProps: { value: 'IL' } },
  { header: 'Italy', accessibilityItemProps: { value: 'IT' } },
  { header: 'Jamaica', accessibilityItemProps: { value: 'JM' } },
  { header: 'Japan', accessibilityItemProps: { value: 'JP' } },
  { header: 'Jersey', accessibilityItemProps: { value: 'JE' } },
  { header: 'Jordan', accessibilityItemProps: { value: 'JO' } },
  { header: 'Kazakhstan', accessibilityItemProps: { value: 'KZ' } },
  { header: 'Kenya', accessibilityItemProps: { value: 'KE' } },
  { header: 'Kiribati', accessibilityItemProps: { value: 'KI' } },
  {
    header: "Korea, Democratic People's Republic of",
    accessibilityItemProps: { value: 'KP' }
  },
  { header: 'Korea, Republic of', accessibilityItemProps: { value: 'KR' } },
  { header: 'Kuwait', accessibilityItemProps: { value: 'KW' } },
  { header: 'Kyrgyzstan', accessibilityItemProps: { value: 'KG' } },
  {
    header: "Lao People's Democratic Republic",
    accessibilityItemProps: { value: 'LA' }
  },
  { header: 'Latvia', accessibilityItemProps: { value: 'LV' } },
  { header: 'Lebanon', accessibilityItemProps: { value: 'LB' } },
  { header: 'Lesotho', accessibilityItemProps: { value: 'LS' } },
  { header: 'Liberia', accessibilityItemProps: { value: 'LR' } },
  { header: 'Libyan Arab Jamahiriya', accessibilityItemProps: { value: 'LY' } },
  { header: 'Liechtenstein', accessibilityItemProps: { value: 'LI' } },
  { header: 'Lithuania', accessibilityItemProps: { value: 'LT' } },
  { header: 'Luxembourg', accessibilityItemProps: { value: 'LU' } },
  { header: 'Macao', accessibilityItemProps: { value: 'MO' } },
  {
    header: 'Macedonia, The Former Yugoslav Republic of',
    accessibilityItemProps: { value: 'MK' }
  },
  { header: 'Madagascar', accessibilityItemProps: { value: 'MG' } },
  { header: 'Malawi', accessibilityItemProps: { value: 'MW' } },
  { header: 'Malaysia', accessibilityItemProps: { value: 'MY' } },
  { header: 'Maldives', accessibilityItemProps: { value: 'MV' } },
  { header: 'Mali', accessibilityItemProps: { value: 'ML' } },
  { header: 'Malta', accessibilityItemProps: { value: 'MT' } },
  { header: 'Marshall Islands', accessibilityItemProps: { value: 'MH' } },
  { header: 'Martinique', accessibilityItemProps: { value: 'MQ' } },
  { header: 'Mauritania', accessibilityItemProps: { value: 'MR' } },
  { header: 'Mauritius', accessibilityItemProps: { value: 'MU' } },
  { header: 'Mayotte', accessibilityItemProps: { value: 'YT' } },
  { header: 'Mexico', accessibilityItemProps: { value: 'MX' } },
  {
    header: 'Micronesia, Federated States of',
    accessibilityItemProps: { value: 'FM' }
  },
  { header: 'Moldova, Republic of', accessibilityItemProps: { value: 'MD' } },
  { header: 'Monaco', accessibilityItemProps: { value: 'MC' } },
  { header: 'Mongolia', accessibilityItemProps: { value: 'MN' } },
  { header: 'Montserrat', accessibilityItemProps: { value: 'MS' } },
  { header: 'Morocco', accessibilityItemProps: { value: 'MA' } },
  { header: 'Mozambique', accessibilityItemProps: { value: 'MZ' } },
  { header: 'Myanmar', accessibilityItemProps: { value: 'MM' } },
  { header: 'Namibia', accessibilityItemProps: { value: 'NA' } },
  { header: 'Nauru', accessibilityItemProps: { value: 'NR' } },
  { header: 'Nepal', accessibilityItemProps: { value: 'NP' } },
  { header: 'Netherlands', accessibilityItemProps: { value: 'NL' } },
  { header: 'Netherlands Antilles', accessibilityItemProps: { value: 'AN' } },
  { header: 'New Caledonia', accessibilityItemProps: { value: 'NC' } },
  { header: 'New Zealand', accessibilityItemProps: { value: 'NZ' } },
  { header: 'Nicaragua', accessibilityItemProps: { value: 'NI' } },
  { header: 'Niger', accessibilityItemProps: { value: 'NE' } },
  { header: 'Nigeria', accessibilityItemProps: { value: 'NG' } },
  { header: 'Niue', accessibilityItemProps: { value: 'NU' } },
  { header: 'Norfolk Island', accessibilityItemProps: { value: 'NF' } },
  {
    header: 'Northern Mariana Islands',
    accessibilityItemProps: { value: 'MP' }
  },
  { header: 'Norway', accessibilityItemProps: { value: 'NO' } },
  { header: 'Oman', accessibilityItemProps: { value: 'OM' } },
  { header: 'Pakistan', accessibilityItemProps: { value: 'PK' } },
  { header: 'Palau', accessibilityItemProps: { value: 'PW' } },
  {
    header: 'Palestinian Territory, Occupied',
    accessibilityItemProps: { value: 'PS' }
  },
  { header: 'Panama', accessibilityItemProps: { value: 'PA' } },
  { header: 'Papua New Guinea', accessibilityItemProps: { value: 'PG' } },
  { header: 'Paraguay', accessibilityItemProps: { value: 'PY' } },
  { header: 'Peru', accessibilityItemProps: { value: 'PE' } },
  { header: 'Philippines', accessibilityItemProps: { value: 'PH' } },
  { header: 'Pitcairn', accessibilityItemProps: { value: 'PN' } },
  { header: 'Poland', accessibilityItemProps: { value: 'PL' } },
  { header: 'Portugal', accessibilityItemProps: { value: 'PT' } },
  { header: 'Puerto Rico', accessibilityItemProps: { value: 'PR' } },
  { header: 'Qatar', accessibilityItemProps: { value: 'QA' } },
  { header: 'Reunion', accessibilityItemProps: { value: 'RE' } },
  { header: 'Romania', accessibilityItemProps: { value: 'RO' } },
  { header: 'Russian Federation', accessibilityItemProps: { value: 'RU' } },
  { header: 'Rwanda', accessibilityItemProps: { value: 'RW' } },
  { header: 'Saint Helena', accessibilityItemProps: { value: 'SH' } },
  { header: 'Saint Kitts and Nevis', accessibilityItemProps: { value: 'KN' } },
  { header: 'Saint Lucia', accessibilityItemProps: { value: 'LC' } },
  {
    header: 'Saint Pierre and Miquelon',
    accessibilityItemProps: { value: 'PM' }
  },
  {
    header: 'Saint Vincent and the Grenadines',
    accessibilityItemProps: { value: 'VC' }
  },
  { header: 'Samoa', accessibilityItemProps: { value: 'WS' } },
  { header: 'San Marino', accessibilityItemProps: { value: 'SM' } },
  { header: 'Sao Tome and Principe', accessibilityItemProps: { value: 'ST' } },
  { header: 'Saudi Arabia', accessibilityItemProps: { value: 'SA' } },
  { header: 'Senegal', accessibilityItemProps: { value: 'SN' } },
  { header: 'Serbia and Montenegro', accessibilityItemProps: { value: 'CS' } },
  { header: 'Seychelles', accessibilityItemProps: { value: 'SC' } },
  { header: 'Sierra Leone', accessibilityItemProps: { value: 'SL' } },
  { header: 'Singapore', accessibilityItemProps: { value: 'SG' } },
  { header: 'Slovakia', accessibilityItemProps: { value: 'SK' } },
  { header: 'Slovenia', accessibilityItemProps: { value: 'SI' } },
  { header: 'Solomon Islands', accessibilityItemProps: { value: 'SB' } },
  { header: 'Somalia', accessibilityItemProps: { value: 'SO' } },
  { header: 'South Africa', accessibilityItemProps: { value: 'ZA' } },
  {
    header: 'South Georgia and the South Sandwich Islands',
    accessibilityItemProps: { value: 'GS' }
  },
  { header: 'Spain', accessibilityItemProps: { value: 'ES' } },
  { header: 'Sri Lanka', accessibilityItemProps: { value: 'LK' } },
  { header: 'Sudan', accessibilityItemProps: { value: 'SD' } },
  { header: 'Suriname', accessibilityItemProps: { value: 'SR' } },
  { header: 'Svalbard and Jan Mayen', accessibilityItemProps: { value: 'SJ' } },
  { header: 'Swaziland', accessibilityItemProps: { value: 'SZ' } },
  { header: 'Sweden', accessibilityItemProps: { value: 'SE' } },
  { header: 'Switzerland', accessibilityItemProps: { value: 'CH' } },
  { header: 'Syrian Arab Republic', accessibilityItemProps: { value: 'SY' } },
  {
    header: 'Taiwan, Province of China',
    accessibilityItemProps: { value: 'TW' }
  },
  { header: 'Tajikistan', accessibilityItemProps: { value: 'TJ' } },
  {
    header: 'Tanzania, United Republic of',
    accessibilityItemProps: { value: 'TZ' }
  },
  { header: 'Thailand', accessibilityItemProps: { value: 'TH' } },
  { header: 'Timor-Leste', accessibilityItemProps: { value: 'TL' } },
  { header: 'Togo', accessibilityItemProps: { value: 'TG' } },
  { header: 'Tokelau', accessibilityItemProps: { value: 'TK' } },
  { header: 'Tonga', accessibilityItemProps: { value: 'TO' } },
  { header: 'Trinidad and Tobago', accessibilityItemProps: { value: 'TT' } },
  { header: 'Tunisia', accessibilityItemProps: { value: 'TN' } },
  { header: 'Turkey', accessibilityItemProps: { value: 'TR' } },
  { header: 'Turkmenistan', accessibilityItemProps: { value: 'TM' } },
  {
    header: 'Turks and Caicos Islands',
    accessibilityItemProps: { value: 'TC' }
  },
  { header: 'Tuvalu', accessibilityItemProps: { value: 'TV' } },
  { header: 'Uganda', accessibilityItemProps: { value: 'UG' } },
  { header: 'Ukraine', accessibilityItemProps: { value: 'UA' } },
  { header: 'United Arab Emirates', accessibilityItemProps: { value: 'AE' } },
  { header: 'United Kingdom', accessibilityItemProps: { value: 'GB' } },
  { header: 'United States', accessibilityItemProps: { value: 'US' } },
  {
    header: 'United States Minor Outlying Islands',
    accessibilityItemProps: { value: 'UM' }
  },
  { header: 'Uruguay', accessibilityItemProps: { value: 'UY' } },
  { header: 'Uzbekistan', accessibilityItemProps: { value: 'UZ' } },
  { header: 'Vanuatu', accessibilityItemProps: { value: 'VU' } },
  { header: 'Venezuela', accessibilityItemProps: { value: 'VE' } },
  { header: 'Vietnam', accessibilityItemProps: { value: 'VN' } },
  {
    header: 'Virgin Islands, British',
    accessibilityItemProps: { value: 'VG' }
  },
  { header: 'Virgin Islands, U.S.', accessibilityItemProps: { value: 'VI' } },
  { header: 'Wallis and Futuna', accessibilityItemProps: { value: 'WF' } },
  { header: 'Western Sahara', accessibilityItemProps: { value: 'EH' } },
  { header: 'Yemen', accessibilityItemProps: { value: 'YE' } },
  { header: 'Zambia', accessibilityItemProps: { value: 'ZM' } },
  { header: 'Zimbabwe', accessibilityItemProps: { value: 'ZW' } },
];

export const BILLING_PAGE = '/settings/billing';
export const SUBSCRIPTION_EXPIRED_PAGE = '/expired';

export const REQUEST_INITIAL_FILTER_VALUE = false;
export const BULK_EDIT_VALUES = {
  RequesterId: {
    value: null,
    required: false
  },
  StatusId: {
    value: null,
    required: false
  },
  PriorityId: {
    value: null,
    required: false
  },
  TicketTypeId: {
    value: null,
    required: false
  },
  CategoryId: {
    value: null,
    required: false
  },
  AssigneeId: {
    value: null,
    required: false
  },
  DueDate: {
    value: null,
    required: false
  },
  SupportGroupId: {
    value: null,
    required: false
  },
  TeamId: {
    value: null,
    required: false
  },
  ResolutionDate: {
    value: null,
    required: false
  },
  Tags: {
    value: null,
    required: false
  },
  AffectedUsers: {
    value: null,
    required: false
  },
  TicketCollaborators: {
    value: null,
    required: false
  }
};

export const LICENSE_FEATURE = {
  ValidSubscription: 'ValidSub',
  TicketDeflection: 'TicketDeflection',
  APIAccess: 'ApiAccess',
  TicketTypes: 'TicketTypes',
  IntuneConnector: 'Intune',
  PowerAutomateConnector: 'PowerAutomate',
  PowerBIConnector: 'PowerBI',
  MultiDepartment: 'MultiDepartment',
  ServiceLevelAgreements: 'SLAs',
  Approvals: 'Approvals',
  Surveys: 'Surveys',
  RelatedTickets: 'RelatedTickets',
  ScheduledAutomation: "ScheduledAutomation",
  NotificationAction: "NotificationAction",
  TicketTasks: "TicketTasks",
  CustomViews: "CustomViews",
  TicketLifecycle: "TicketLifecycle",
  CustomForms: "CustomForms",
  Collaborators: "Collaborators",
  AffectedUsers: "AffectedUsers",
  EmailConnector: "EmailConnector",
  TicketTags: "TicketTags",
  CustomStatus: "CustomStatus",
  TicketTemplates: "TicketTemplates",
  TicketPortal: "TicketPortal",
  TemplateDeflection: "TemplateDeflection",
  MyWork: "MyWork",
  MyGroupWork: "MyGroupWork",
  MultiEmailInbox: "MultiEmailInbox",
  PowerAutomateTask: "PowerAutomateTask",
  ConversationalAi: "ConversationalAI",
  NotificationCenter: "NotificationCenter",
  ResolutionNote: "ResolutionNote",
  GroupChat: "GroupChat",
  ServiceCatalog: "ServiceCatalog",
  MultiTurnCard: "MultiTurnCard",
  CustomProperties: "CustomProperties",
  TimeTracking: "TimeTracking",
  // Licence only - no tenant setting - so it is deliberately NOT in FeatureCache's
  // expiredFeatures list. Nothing can change it mid-session; a licence change lands at login.
  RoundRobinAssignment: "RoundRobinAssignment",
  PermissionScoping: "PermissionScoping"
};

export const PRODUCT_LICENSE = {
  AnalystAccess: 'AnalystAccess'
}

export const markdownComponents = {
  a(props) {
    const {node, ...rest} = props;
    const matches = [...node.properties.href.matchAll(/mention:(?<id>.+)/gmi)];
    if (matches.length > 0) {
        const mentioned = matches[0].at(-1);
        return <PersonCardMention href={node.properties.href} element={rest.children} mentionedEmail={mentioned} />
    }
    
    return (<a target="_blank" style={{ textDecoration: 'underline' }} {...rest} />);
  },
  ol(props) {
    const {node, ...rest} = props;
    return <ol className='ml-2 list-decimal defaultStyle' {...rest} />
  },
  ul(props) {
    const {node, ...rest} = props;
    return <ul className='ml-2 list-disc defaultStyle' {...rest} />
  },
  h1(props) {
    const {node, ...rest} = props;
    return <h1 className='defaultStyle' {...rest} />
  },
  h2(props) {
    const {node, ...rest} = props;
    return <h2 className='defaultStyle' {...rest} />
  },
  h3(props) {
    const {node, ...rest} = props;
    return <h3 className='defaultStyle' {...rest} />
  },
  h4(props) {
    const {node, ...rest} = props;
    return <h4 className='defaultStyle' {...rest} />
  },
  h5(props) {
    const {node, ...rest} = props;
    return <h5 className='defaultStyle' {...rest} />
  },
  h6(props) {
    const {node, ...rest} = props;
    return <h6 className='defaultStyle' {...rest} />
  },
  code(props) {
    const {node, ...rest} = props;
    return <code className='border rounded-sm px-1 mx-1 border-gray-300' {...rest} />
  }
};

export enum SLAActionType {
  ApproachBreach = 1,
  Breached = 2
}

export enum FilterDataType{
  Boolean = "boolean",
  String = "string",
  Number = "number",
  Date = "date",
  Time = "time",
  Any = "any"
}

export enum UnitOfTime {
  Minutes,
  Seconds,
  Hours,
  Days,
  Months,
  Years
}

export enum NotificationRecipient {
  Group,
  User,
  Assignee
}

export const UnitOfTimeDropdownModel = [
  {
    key: 'seconds',
    header: t('sla.time.seconds'),
    value: 'Seconds',
    Id: UnitOfTime.Seconds
  },
  {
    key: 'minutes',
    header: t('sla.time.minutes'),
    value: 'Minutes',
    Id: UnitOfTime.Minutes
  },
  {
    key: 'hours',
    header: t('sla.time.hours'),
    value: 'Hours',
    Id: UnitOfTime.Hours
  },
  {
    key: 'days',
    header: t('sla.time.days'),
    value: 'Days',
    Id: UnitOfTime.Days
  },
  {
    key: 'months',
    header: t('sla.time.months'),
    value: 'Months',
    Id: UnitOfTime.Months
  },
  {
    key: 'years',
    header: t('sla.time.years'),
    value: 'Years',
    Id: UnitOfTime.Years
  }
];

export const NotificationRecipientModel = [
  {
    key: 'Group',
    header: 'Group',
    value: 'Group',
    Id: NotificationRecipient.Group
  },
  {
    key: 'user',
    header: 'User',
    value: 'User',
    Id: NotificationRecipient.User
  },
  {
    key: 'asignee',
    header: 'Assignee',
    value: 'Assignee',
    Id: NotificationRecipient.Assignee
  }
];

export enum TicketSlaState {
  Active = 'Active',
  ApproachBreached = 'Approach Breached',
  Breached = 'Breached',
  Satisfied = 'Satisfied'
}

export const SlaStateStrings = {
  Active: t('sla.status.active'),
  "Approach Breached": t('sla.status.approach'),
  Breached: t('sla.status.breached'),
  Satisfied: t('sla.status.satisfied')
};

export const SLA = {
  CREATE_SLA: t('sla.create-sla'),
  INFO_SLA: t('sla.info-sla'),
  TICKET_STATUS: t('sla.ticket-status'),
  IF_TICKET_STATUS: t('sla.if-ticket-status'),
  TITLE: t('sla.title-const'),
  INFORMATION: t('sla.information'),
  SLA_NAME: t('sla.sla-name'),
  NAME: t('sla.name'),
  SERVICE_LEVEL_AGREEMENT: t('sla.service-level-agreement-cons'),
  SLA_INFO_DESCRIPTION: t('sla.sla-info-description'),
  SLA: t('sla.sla'),
  ROUTE_NAME_SLA: 'sla',
  GETTING_ALL_SLA: t('sla.getting-all-sla'),
  TOGGLING_SLA: t('sla.toggling-sla'),
  DELETING_SLA: t('sla.deleting-sla'),
  SLA_STATE: t('sla.sla-state'),
  UNIT_OF_TIME: t('sla.unit-of-time'),
  GENERAL_SLA_INFORMATION: t('sla.general-sla-information'),
  TICKET_CRITERIA: t('sla.ticket-criteria'),
  SLA_UPDATE_HEADER:
  t('sla.sla-update-header'),
  SLA_DOING_SO: t('sla.sla-doing-so'),
  SLA_RECALCULATE: t('sla.sla-recalculate'),
  SLA_POSSIBLE_TICKETS:
  t('sla.sla-possible-tickets'),
  SLA_REQUIRED_FIELDS: t('sla.sla-required-fields'),
};

export const CRITERIA_META_DATA_FILTER = {
  id: 0,
  property: '',
  operator: '',
  value: ''
};

export const DEFAULT_SLA_TICKET_CRITERIA: SlaTicketCriteria = {
  Id: 0,
  arrowHeight: 50,
  logicOperator: 'And',
  criteriaMetaData: [CRITERIA_META_DATA_FILTER]
};

export const DEFAULT_SLA_INFO: SlaInfo = {
  name: '',
  statusList: [],
  isActive: false
};

export const DEFAULT_SLA_SLIDING_METADTA: SlaBreachMeta = {
  timeDigitPart: 0,
  timeUnit: UnitOfTimeDropdownModel[2].value
};

export const TEMPLATE_DROPDOWN_RETURN_VALUE = {
  STATUS_ID: 'StatusId',
  STATUS: 'Status',
  CATEGORY_ID: 'CategoryId',
  CATEGORY: 'Category',
  TICKET_TYPE_ID: 'TicketTypeId',
  TICKET_TYPE: 'TicketType',
  PRIORITY_ID: 'PriorityId',
  PRIORITY: 'Priority',
  LIFECYCLE_ID: 'LifecycleId',
  LIFECYCLE: 'Lifecycle',
  TAG: 'Tag',
  TEAM: 'Team',
  GROUP: 'SupportGroup',
};

export const TEMPLATE_DROPDOWN_RETURN_LABEL = {
  [TEMPLATE_DROPDOWN_RETURN_VALUE.STATUS]: 'Status',
  [TEMPLATE_DROPDOWN_RETURN_VALUE.CATEGORY]: 'Category',
  [TEMPLATE_DROPDOWN_RETURN_VALUE.TICKET_TYPE]: 'Ticket Type',
  [TEMPLATE_DROPDOWN_RETURN_VALUE.PRIORITY]: 'Priority',
  [TEMPLATE_DROPDOWN_RETURN_VALUE.TAG]: 'Tag',
  [TEMPLATE_DROPDOWN_RETURN_VALUE.TEAM]: 'Team',
  [TEMPLATE_DROPDOWN_RETURN_VALUE.GROUP]: 'Group'
};

export enum TicketApprovalState {
  Approved = 1,
  Rejected = 2,
  Pending = 3
}

const statusPill = 'inline-block capitalize pt-0.5 pb-1 px-3 rounded-full';

export const CSS_CLASS = {
  STATUS_PILL_CLOSED: `bg-gray-100 text-gray-600 ${statusPill}`,
  STATUS_PILL_ACTIVE: `bg-green-100 text-green-600 ${statusPill}`,
  STATUS_PILL_RESOLVED: `resolved-pill ${statusPill}`,
  STATUS_PILL_ERROR: `error-pill ${statusPill}`,
  STATUS_PILL_SKIPPED: `bg-yellow-100 text-yellow-600 ${statusPill}`,
  STATUS_PILL_OTHERS: `bg-blue-100 text-blue-600 ${statusPill}`,
  LIFECYCLE_COMPLETED: 'phase-ribbon phase-ribbon-completed',
  LIFECYCLE_FAILED: 'phase-ribbon phase-ribbon-failed',
  LIFECYCLE_INPROGRESS: 'phase-ribbon phase-ribbon-inprogress',
  LIFECYCLE_NOTSTARTED: 'phase-ribbon phase-ribbon-notstarted',
  LIFECYCLE_PASTPHASE: 'phase-ribbon phase-ribbon-pastphase'
}

export const LIFECYCLE = {
  NAME: t('lifecycle.lifecycle'),
  NEW_LIFECYCLE: t('lifecycle.new-lifecycle'),
  GETTING_ALL_LIFECYCLE: t('lifecycle.getting-all-lifecycle'),
  APPLYING_LIFECYCLE: t('lifecycle.apply-lifecycle-to-ticket'),
  CREATING_LIFECYCLE: t('lifecycle.creating-new-lifecycle'),
  UPDATE_LIFECYCLE: t('lifecycle.updating-lifecycle'),
  EXISTING_LIFECYCLE: t('lifecycle.lifecycle'),
  SELECT_LIFECYCLE: t('lifecycle.select-a-lifecycle'),
  SELECT_LIFECYCLE_DESCRIPTION: t('select-from-existing-lifecycle'),
  INFORMATION: t('lifecycle.lifecycle-information'),
  TOOLBAR_TITLE: t('lifecycle.toolbar-title'),
  BREADCRUMB_SETTINGS: t('lifecycle.breadcrumb-settings'),
  NO_ACCESS_TO_CREATE: t('lifecycle.no-access-to-create-message'),
  UPGRADE_PLAN: t('lifecycle.upgrade-plan-message'),
  FETCHING_LIFECYCLE: t('lifecycle.fetching-lifecycle-data'),
  SAVING_LIFECYCLE: t('lifecycle.saving-lifecycle-data'),
  SAVE: t('lifecycle.save'),
  PHASES: t('lifecycle.phases'),
  ADD_PHASE: t('lifecycle.add-phase'),
  DELETE_PHASE: t('lifecycle.delete-phase'),
  DELETE_PHASE_MESSAGE: t('lifecycle.delete-phase-message'),
  COMPLETE: t('lifecycle.complete'),
  FAILED: t('lifecycle.failed'),
  ACTIONS: t('lifecycle.actions'),
  MOVE_TRANSITION: t('lifecycle.transition-move-message'),
  APPROVAL: t('lifecycle.approval'),
  TASK: t('lifecycle.task'),
  ACTIVITIES: t('lifecycle.activities'),
  TRANSITION_REASON: t('lifecycle.transition-reason'),
  ADD_TASK: t('lifecycle.add-task'),
  ADD_APPROVAL: t('lifecycle.add-approval'),
  TITLE: t('lifecycle.title'),
  ASSIGNEE: t('lifecycle.task-assignee'),
  NO_ASSIGNEE: t('lifecycle.no-assignee'),
  USER_NOT_FOUND: t('lifecycle.user-not-found'),
  TASKS: t('lifecycle.tasks'),
  DELETE_TASK: t('lifecycle.delete-task'),
  DELETE_TASK_MESSAGE: t('lifecycle.delete-task-message'),
  APPORVALS: t('lifecycle.approvals'),
  YOU: t('lifecycle.you'),
  APPROVED_ON: t('lifecycle.approved-on'),
  REJECTED_ON: t('lifecycle.rejected-on'),
  PENDING_APPROVAL: t('lifecycle.pending-approval'),
  ADDITIONAL_INFO: t('lifecycle.additional-info'),
  DELETE_APPROVAL: t('lifecycle.delete-appoval'),
  DELETE_APPROVAL_MESSAGE: t('lifecycle.delete-appoval-message'),
  DELETE_TRANSITION: t('lifecycle.delete-transition'),
  DELETE_TRANSITION_MESSAGE: t('lifecycle.delete-transition-message'),
  USE_DEFAULT_LOGIC: t('lifecycle.use-default-logic'),
  ALL_COMPLETED_MESSAGE: t('lifecycle.all-completed-message'),
  USE_LOGIC_BUILDER: t('lifecycle.use-logic-builder'),
  DEFINE_TRANSITION_CONDITION: t('lifecycle.define-transition-condition-message'),
  REASON: t('lifecycle.reason'),
  ENTER_A_MESSAGE: t('lifecycle.enter-a-message'),
  ADD_TRANSITION: t('lifecycle.add-transition'),
  ADD_RULE_GROUP: t('lifecycle.add-rule-group'),
  DESCRIPTION: t('lifecycle.description'),
  ENTER_DESCRIPTION: t('lifecycle.enter-description'),
  AUTOMATIC_STATUS_CHANGE: t('lifecycle.automatic-status-change'),
  REQUIRED_FIELD_MESSAGE: t('lifecycle.required-field-message'),
  ADD: t('lifecycle.add'),
  CLOSE: t('lifecycle.close'),
  TITLE_WITH_MAX_LENGTH: t('lifecycle.title-with-max-length'),
  REQUIRED_APPROVER_RESPONSE: t('lifecycle.required-approvers-response'),
  ADDITIONAL_DETAILS: t('lifecycle.additional-detatails'),
  APPROVERS: t('lifecycle.approvers'),
  PHASE: t('lifecycle.phase'),
  SELECT_PHASE: t('lifecycle.select-phase'),
  MOVE: t('lifecycle.move'),
  SELECT_MOVE: t('lifecycle.select-move'),
  ACTION: t('lifecycle.action'),
  PROPERTY : t('lifecycle.property'),
  SELECT_PROPERTY: t('lifecycle.select-property'),
  ITEM: t('lifecycle.item'),
  SELECT_ITEM: t('lifecycle.select-item'),
  VALUE: t('lifecycle.value'),
  SELECT_VALUE: t('lifecycle.select-value'),
  REMOVE: t('lifecycle.remove'),
  AND: t('lifecycle.and'),
  RULES: t('lifecycle.rules'),
  ADD_FILTER: t('lifecycle.add-filter'),
  SEARCH: t('lifecycle.search'),
  NO_LIFECYCLE_SHOW : t('lifecycle.no-lifecycle-show'),
  SEE_MORE: t('lifecycle.see-more'),
  SEE_LESS: t('lifecycle.see-less'),
  NOTE: t('lifecycle.note'),
  POWER_AUTOMATE_TASKS: t('lifecycle.power-automate-tasks'),
  POWER_AUTOMATE_TASK: t('lifecycle.power-automate-task'),
  FLOW: t('lifecycle.flow'),
  ADD_FLOW: t('lifecycle.add-flow'),
  DELETE_POWERAUTOMATE_TASK: t('lifecycle.delete-powerautomate-task'),
  DELETE_POWERAUTOMATE_TASK_MESSAGE: t('lifecycle.delete-powerautomate-task-message'),
  POWERAUTOMATE_TASK_TITLE: t('lifecycle.powerautomate-task-title'),
  POWERAUTOMATE_PORTAL: t('lifecycle.powerautomate-portal'),
  NO_TEAM: t('lifecycle.no-team'),
  NO_GROUP: t('lifecycle.no-group'),
  TRANSITION:  t('lifecycle.transition'),
  MANUAL_TRANSITION_TO:  t('lifecycle.manual-transition-to'),
  MANUAL_TRANSITION_FROM:  t('lifecycle.manual-transition-from'),
  COMPLETED: t('lifecycle.completed'),
  RESOLUTION_NOTE: t('resolution-note.resolution-note'),
  RESOLUTION_CATEGORY: t('resolution-note.resolution-category'),
  RESOLUTION_NOTE_INTERNAL: t('resolution-note.resolution-note-internal')
}

type ListColumnKeyType = "Icon" | "Id" | "Title" | "Assignee" | "Status" | "GroupChat" | "Requester" | "Team" | "Group" | "Type" | "Category"
  | "Priority" | "LastModifiedDate" | "CreatedDate" | "DueDate" | "ResolutionDate" | "Lifecycle" | "Phase" | "SLA"
  | "AffectedUsers" | "Collaborators" | "ResolutionCategory" | "Note" | "InternalNote" | "DraftKB" | "TotalAgentTime"
export const ListColumnKey: { [key in ListColumnKeyType]: ISortOrderBy } = {
  Icon: 0,
  Id: 1,
  Title: 2,
  Assignee: 3,
  Status: 4,
  GroupChat:5,
  Requester: 6,
  Team: 7,
  Group: 8,
  Type: 9,
  Category: 10,
  Priority: 11,
  LastModifiedDate: 12,
  CreatedDate: 13,
  DueDate: 14,
  ResolutionDate: 15,
  Lifecycle: 16,
  Phase: 17,
  SLA: 18,
  AffectedUsers: 19,
  Collaborators: 20,
  ResolutionCategory: 21,
  Note: 22,
  InternalNote: 23,
  DraftKB: 24,
  TotalAgentTime: 25}

export const DASHBOARD_TABLE_COLUMNS: { [key in string]: [ISortOrderBy, TicketColumnOrderByValuesType] } = {
  [t('ticket.ticket-list.id')]: [ListColumnKey.Id, 'Id'],
  [t('ticket.ticket-list.type')]: [ListColumnKey.Type, 'TicketType/Value'],
  [t('ticket.ticket-list.request')]: [ListColumnKey.Title, 'Title'],
  [t('ticket.ticket-list.status')]: [ListColumnKey.Status, 'Status/Value'],
  [t('ticket.ticket-list.group-chat')]: [ListColumnKey.GroupChat, 'GroupChat/Members'],
  [t('ticket.ticket-list.requester')]: [ListColumnKey.Requester, 'Requester/FullName'],
  [t('ticket.ticket-list.category')]: [ListColumnKey.Category, 'Category/Value'],
  [t('ticket.ticket-list.priority')]: [ListColumnKey.Priority, 'Priority/Value'],
  [t('ticket.ticket-list.sla')]: [ListColumnKey.SLA, 'Id'],
  [t('ticket.ticket-list.team')]: [ListColumnKey.Team, 'Team/Name'],
  [t('ticket.ticket-list.group')]: [ListColumnKey.Group, 'SupportGroup/Name'],
  [t('ticket.ticket-list.assignee')]: [ListColumnKey.Assignee, 'Assignee/FullName'],
  Lifecycle: [ListColumnKey.Lifecycle, 'TicketLifecycle/Lifecycle/Title'],
  Phase: [ListColumnKey.Phase, 'TicketLifecycle/Phases/Name'],
  [t('ticket.ticket-list.last-modified-date')]: [ListColumnKey.LastModifiedDate, 'ModifiedDate'],
  [t('ticket.ticket-list.created-date')]: [ListColumnKey.CreatedDate, 'CreatedDate'],
  [t('ticket.ticket-list.due-date')]: [ListColumnKey.DueDate, 'DueDate'],
  [t('ticket.ticket-list.resolution-date')]: [ListColumnKey.ResolutionDate, 'ResolutionDate'],
  [t('resolution-note.resolution-category')]: [ListColumnKey.ResolutionCategory, 'Resolution/ResolutionCategory/Value'],
  [t('resolution-note.resolution-note')]: [ListColumnKey.Note, 'Resolution/Note'],
  [t('resolution-note.resolution-note-internal')]: [ListColumnKey.InternalNote, 'Resolution/InternalNote'],
  [t('resolution-note.draft-kb')]: [ListColumnKey.DraftKB, 'Resolution/DraftKB'],
  // Key order here drives the order of the column picker, so this sits last, matching
  // the ticket list's own column order (ClassDetailList's _cols). Hidden entirely when
  // time tracking is off - see filtersByFeature.
  [t('ticket.ticket-list.total-agent-time')]: [ListColumnKey.TotalAgentTime, 'TotalTimeSpentMinutes']
};
export const SELECTED_COLUMNS: FEViewColumn[] = Object.keys(DASHBOARD_TABLE_COLUMNS).map((key) => ({ id: DASHBOARD_TABLE_COLUMNS[key][0], label: key }));

type TicketListColumnIdsType = { [key in ISortOrderBy]: TicketColumnOrderByValuesType }
export const TICKET_LIST_COLUMN_IDS: TicketListColumnIdsType = Object.values(DASHBOARD_TABLE_COLUMNS).reduce((acc, current) => {
	const obj = {[current[0]]: current[1]}
	return {...acc, ...obj};
}, {} as TicketListColumnIdsType);

// FILTERS
export const FILTERS = {
  DUE: {
    id: 0,
    title: t('ticket.child-filter.due'),
    sortOrder: 14
  },
  STATUS: {
    id: 1,
    title: t('ticket.child-filter.status'),
    sortOrder: 5,
  },
  PRIORITY: {
    id: 2,
    title: t('ticket.child-filter.priority'),
    sortOrder: 12,
  },
  CATEGORY: {
    id: 3,
    title: t('ticket.child-filter.category'),
    sortOrder: 3,
  },
  ASSIGNEE: {
    id: 4,
    title: t('ticket.child-filter.assignee'),
    sortOrder: 10,
  },
  TEAM: {
    id: 5,
    title: t('ticket.child-filter.team'),
    sortOrder: 8,
  },
  GROUP: {
    id: 6,
    title: t('ticket.child-filter.group'),
    sortOrder: 9,
  },
  TICKET_TYPE: {
    id: 7,
    title: t('ticket.child-filter.ticket-type'),
    sortOrder: 4,
  },
  TAGS: {
    id: 8,
    title: t('ticket.child-filter.tags'),
    sortOrder: 6
  },
  RESOLUTION: {
    id: 9,
    title: t('ticket.child-filter.resolution'),
    sortOrder: 16,
  },
  REQUESTERS: {
    id: 10,
    title: t('ticket.child-filter.requester'),
    sortOrder: 0,
  },
  LIFECYCLE: {
    id: 11,
    title: t('ticket.child-filter.lifecycle'),
    sortOrder: 7,
  },
  CREATED_DATE: {
    id: 12,
    title: t('ticket.child-filter.created-date'),
    sortOrder: 13,
  },
  MODIFIED_DATE:{
    id: 13,
    title: t('ticket.child-filter.modified-date'),
    sortOrder: 15,
  },
  AffectedUsers: {
    id: 14,
    title: t('ticket.child-filter.affected-users'),
    sortOrder: 1,
  },
  TicketCollaborators: {
    id: 15,
    title: t('ticket.child-filter.collaborators'),
    sortOrder: 11,
  },
  Title: {
    id: 16,
    title: t('ticket.ticket-list.request'),
    sortOrder: 2,
  },
  ResolutionCategory: {
    id: 17,
    title: t('resolution-note.resolution-category'),
    sortOrder: 17,
  },
  Note: {
    id: 18,
    title: t('resolution-note.resolution-note'),
    sortOrder: 18,
  },
  InternalNote: {
    id: 19,
    title: t('resolution-note.resolution-note-internal'),
    sortOrder: 19,
  },
  DraftKB: {
    id: 20,
    title: t('resolution-note.draft-kb'),
    sortOrder: 20,
  },
  // sortOrder 21 is the first free slot after the built-in filters, and custom properties are
  // appended at 1000 + their own order (TicketBoard.prepareFiltersData), so this lands where it
  // was asked for: last of the out-of-the-box filters, ahead of every custom property.
  TOTAL_AGENT_TIME: {
    id: 21,
    title: t('ticket.ticket-list.total-agent-time'),
    sortOrder: 21,
  }
}

export enum MyWorkListViewType {
  All,
  Tickets,
  Tasks,
  Approvals,
}

export const FEATURE_NOT_AVAILABLE = {
  TaskHeader: t('common.task-feature-unavailable.header'),
  TaskSubHeader: t('common.task-feature-unavailable.subheader'),
  ApprovalHeader: t('common.approval-feature-unavailable.header'),
  ApprovalSubHeader: t('common.approval-feature-unavailable.subheader')
}

export const STORAGE_CONSTANTS = {
  VIEW_ID: {
    CUSTOM_VIEW_ID: 'custom_view_id',
    DEFAULT_VIEW_ID: 'default_view_id',
  },
  SORT_ORDER: 'sort_order',
  CONFIGURED_COLUMNS: 'configured_columns',
  CHILD_FILTER: {
    DROPDOWN_INPUT_VALUE: 'child_filter_dropdown_input_value',
    DROPDOWN_VALUES: 'child_filter_dropdown_values',
    DROPDOWN_COUNT: 'child_filter_dropdown_count',
  },
  MY_WORK_LIST: {
    SHOW_CLOSED: 'my_work_list_show_closed',
    TAB: 'my_work_list_tab',
    SORT_ORDER: {
      [MyWorkListViewType.All]: 'tab_all_sort_order',
      [MyWorkListViewType.Tickets]: 'tab_tickets_sort_order',
      [MyWorkListViewType.Tasks]: 'tab_tasks_sort_order',
      [MyWorkListViewType.Approvals]: 'tab_approvals_sort_order',
    },
    LAST_PAGE_PATH: 'my_work_last_page_path'
  },
  MY_GROUP_WORK: {
    SHOW_CLOSED: 'my_group_work_show_closed',
    TAB: 'my_group_work_tab',
    SORT_ORDER: {
      [MyWorkListViewType.All]: 'my_group_work_tab_all_sort_order',
      [MyWorkListViewType.Tickets]: 'my_group_work_tab_tickets_sort_order',
      [MyWorkListViewType.Tasks]: 'my_group_work_tab_tasks_sort_order',
      [MyWorkListViewType.Approvals]: 'my_group_work_tab_approvals_sort_order',
    },
    LAST_PAGE_PATH: 'my_group_work_last_page_path'
  }
}

export const NON_SORTABLE_COLUMNS: number[] = [ListColumnKey.Phase, ListColumnKey.AffectedUsers, ListColumnKey.Collaborators, ListColumnKey.SLA, ListColumnKey.DraftKB, ListColumnKey.GroupChat];
export const ADD_APPROVALS_NOTE: string = t('ticket-details.edit-ticket-form.approval.click-add-approval');
export const ADD_TASKS_NOTE: string = t('ticket-details.edit-ticket-form.task.click-add-task');
export const USER_TYPE = {
  COLLABORATOR: t('requests.user-type.collaborator'),
  AFFECTED_USER: t('requests.user-type.affected-user'),
  REQUESTER: t('requests.user-type.requester'),
  ASSIGNEE: t('requests.user-type.assignee')
}

export const AUTOMATION_EMAIL = {
  DEFAULT_BODY: `<p>Hey {{Requester.FirstName}},</p>
  <p>Here is an update on your ticket,</p>
  <p>Latest Comment: {{LatestComment}}</p>
  <p>Category: {{Category}}</p>
  <p>Assignee: {{Assignee}}</p>
  <p>Group: {{Group}}</p>
  <p>You can reply to this ticket to send us any updates.</p>
  <p>Thanks</p>
  `,
  DEFAULT_SUBJECT: `#{{TicketId}} - {{Request}}`
} 

export const WARNING_NOTE = t('requests.comment-warning-note');

export const customClassNames = mergeStyleSets({
  tikitBoardBody: {
    height: 'calc(100% - 85px) !important',
    top: '0px',
    overflow: 'scroll',
    position: 'relative',
    // Mobile Safari/Chrome sometimes fail to repaint this container when its content
    // is replaced via JS (e.g. a new ticket list after switching views) rather than by
    // user touch/scroll, leaving the screen blank until something else nearby forces a
    // repaint. Promoting it to its own compositing layer keeps it painting immediately.
    WebkitOverflowScrolling: 'touch',
    transform: 'translateZ(0)'
  }
});
export const BooleanProp = ['closed','ismerged','isrequiredbyall','isprivate', 'draftkb', 'resolution_draftkb'];

export const AutomationEditorStyle = mergeStyleSets({
  customForm: {
    overflow:'hidden',
    background: 'var(--mgt-theme-background) !important',
    '.ac-textBlock': {
      padding: '5px 0 !important',
      color: 'var(--mgt-theme-foreground) !important'
    },
    '.ac-richTextBlock > span': {
      color: 'var(--mgt-theme-foreground) !important'
    },
    '.ac-selectable': {pointerEvents:'none'},
    textarea:{pointerEvents:'none'},
    button: {cursor: 'default'},
    input:{pointerEvents:'none'},
    a: {cursor: 'default', textDecoration: 'none !important', pointerEvents:'none'},
    div:{cursor: 'default'},
    select:{pointerEvents:'none'}
  }
});

export const toolbarOptions={
  options:['inline',
  'list',
  'link',
  'emoji',
  'image',
  'remove',
  'history',],
  
  inlineOption: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['bold',
    'italic']
  }
};

export const AutomationToggleStyle={
  Enabled:{
    background: PRIMARY_COLOR_STYLE.color,
    opacity: 1,
    marginRight: '5px'
  },
  Disabled:{marginRight: '5px'}
};

export const IsAgentToggleStyle={
  Toggle:{
    opacity: 1,
     position: "relative",
     top: "5px",
     
  },
  IsAgentMode:{
    background: "black"
  },
  IsAdminMode:{
    background: PRIMARY_COLOR_STYLE.color
  }
} as const;




export const CardList = {
  AutomationNotificationCard:{"type":"AdaptiveCard","body":[{"type":"ColumnSet","columns":[{"width":"stretch","items":[{"id":"customTitle","type":"TextBlock","text":"#Title#","weight":"Bolder","wrap":true}]}]},{"id":"customBody","type":"TextBlock","text":"#Body#","wrap": true}],"actions":[{"type":"Action.Submit","title":"View Ticket","data":{"msteams":{"type":"imBack","value":"View Ticket 70306"}}}, {"type":"Action.OpenUrl","title":"Open Group Chat", "id":"groupChatButton"}, {"type":"Action.OpenUrl","title":"Open in Web"}],"msteams":{"width":"Full"},"$schema":"https://adaptivecards.io/schemas/adaptive-card.json","version":"1.4"},
  TicketTaskCardJson:{"type":"AdaptiveCard","body":[{"type":"ColumnSet","columns":[{"type":"Column","width":"stretch","items":[{"id":"customTitle","type":"TextBlock","weight":"Bolder","text":"#Title#","wrap":true}],"style":"emphasis","bleed":true}]},{"type":"TextBlock","size":"Large","weight":"Bolder","text":"[Active]: Ticket #70402","wrap":true},{"type":"TextBlock","text":"Modified {{DATE(2023-09-24T14:06:22Z,SHORT)}} at {{TIME(2023-09-24T14:06:22Z)}}","size":"Small","spacing":"None"},{"id":"customBody","type":"TextBlock","text":"#Body#","wrap": true},{"type":"Container","items":[{"type":"ColumnSet","columns":[{"type":"Column","width":"60px","items":[{"type":"TextBlock","text":"Status:","weight":"Bolder","wrap":true}],"height":"stretch","verticalContentAlignment":"Center"},{"type":"Column","width":"stretch","items":[{"type":"Input.ChoiceSet","choices":[{"title":"Not Started","value":74}],"id":"taskStatusId","value":75,"errorMessage":"Field is required","isRequired":true}]}]},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"OK","id":"UpdateTask","data":{"ticket":70304,"taskId":20005,"commandId":"UpdateTask","FilterValue":"${FilterValue}","SearchText":"${SearchText}","HideChatWithButton":"${HideChatWithButton}","HideAttachmentButton":"${HideAttachmentButton}","HideMeetingButton":"${HideMeetingButton}"}}]}],"style":"emphasis"},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"View Ticket","data":{"msteams":{"type":"imBack","value":"View Ticket 70304"}}}, {"type":"Action.OpenUrl","title":"Open Group Chat", "id":"groupChatButton"}, {"type":"Action.OpenUrl","title":"Open in Web"}]}],"msteams":{"width":"Full"},"$schema":"https://adaptivecards.io/schemas/adaptive-card.json","version":"1.4"},
  TicketTaskCardJson_tva:{"type":"AdaptiveCard","body":[{"type":"ColumnSet","columns":[{"type":"Column","width":"stretch","items":[{"id":"customTitle","type":"TextBlock","weight":"Bolder","text":"#Title#","wrap":true}],"style":"emphasis","bleed":true}]},{"type":"TextBlock","size":"Large","weight":"Bolder","text":"[Active]: Ticket #70402","wrap":true},{"type":"TextBlock","text":"Modified {{DATE(2023-09-24T14:06:22Z,SHORT)}} at {{TIME(2023-09-24T14:06:22Z)}}","size":"Small","spacing":"None"},{"id":"customBody","type":"TextBlock","text":"#Body#","wrap": true},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"View Ticket","data":{"msteams":{"type":"imBack","value":"View Ticket 70304"}}}, {"type":"Action.OpenUrl","title":"Open Group Chat", "id":"groupChatButton"}, {"type":"Action.OpenUrl","title":"Open in Web"}]}],"msteams":{"width":"Full"},"$schema":"https://adaptivecards.io/schemas/adaptive-card.json","version":"1.4"},
  AutomationNotificationCard_tikit:{"type":"AdaptiveCard","body":[{"type":"ColumnSet","columns":[{"width":"stretch","items":[{"id":"customTitle","type":"TextBlock","text":"#Title#","weight":"Bolder","wrap":true}]}]},{"id":"customBody","type":"TextBlock","text":"#Body#","wrap": true}],"actions":[{"type":"Action.Submit","title":"View Ticket","data":{"msteams":{"type":"imBack","value":"View Ticket 70402"}}}, {"type":"Action.OpenUrl","title":"Open Group Chat", "id":"groupChatButton"}, {"type":"Action.OpenUrl","title":"Open in Web"}],"msteams":{"width":"Full"},"$schema":"https://adaptivecards.io/schemas/adaptive-card.json","version":"1.4"},

  ApprovalTicketNotificationCard_tikit:{"type":"AdaptiveCard","body":[{"type":"Container","style":"emphasis","items":[{"id":"customTitle","type":"TextBlock","size":"Medium","weight":"Bolder","text":"#Title#","spacing":"Small","wrap":true}],"spacing":"Small","bleed":true},{"type":"TextBlock","size":"Medium","weight":"Bolder","text":"[Active] : Ticket #70402","wrap":true},{"type":"ColumnSet","columns":[{"type":"Column","items":[{"type":"Image","style":"Person","url":AdeleIgm,"size":"Small"}],"width":"auto"},{"type":"Column","items":[{"type":"TextBlock","weight":"Bolder","text":"Miriam Graham","wrap":true,"size":"Medium"},{"type":"TextBlock","spacing":"None","text":"Created on {{DATE(2023-10-03T15:41:48Z,SHORT)}}","isSubtle":true,"wrap":true,"size":"Small"}],"width":"stretch"}]},{"id":"customBody","type":"TextBlock","text":"#Body#","wrap":true},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"View Ticket","url":"https://a896-222-127-223-6.ngrok-free.app/requests/70402"},{"type":"Action.OpenUrl","title":"Open Group Chat", "id":"groupChatButton"},  {"type":"Action.OpenUrl","title":"Open in Web"}],"spacing":"Small","horizontalAlignment":"Left"}],"msteams":{"width":"Full"},"$schema":"https://adaptivecards.io/schemas/adaptive-card.json","version":"1.4"},
  ApprovalTicketNotificationCard_tva_requester:{"type":"AdaptiveCard","body":[{"type":"Container","style":"emphasis","items":[{"id":"customTitle","type":"TextBlock","size":"Medium","weight":"Bolder","text":"#Title#","spacing":"Small","wrap":true}],"spacing":"Small","bleed":true},{"type":"TextBlock","size":"Medium","weight":"Bolder","text":"[Active] : Ticket #70402","wrap":true},{"type":"ColumnSet","columns":[{"type":"Column","items":[{"type":"Image","style":"Person","url":AdeleIgm,"size":"Small"}],"width":"auto"},{"type":"Column","items":[{"type":"TextBlock","weight":"Bolder","text":"Miriam Graham","wrap":true,"size":"Medium"},{"type":"TextBlock","spacing":"None","text":"Created on {{DATE(2023-10-03T15:41:48Z,SHORT)}}","isSubtle":true,"wrap":true,"size":"Small"}],"width":"stretch"}]},{"id":"customBody","type":"TextBlock","text":"#Body#","wrap":true},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"View Ticket","url":"https://a896-222-127-223-6.ngrok-free.app/requests/70402"}, {"type":"Action.OpenUrl","title":"Open Group Chat", "id":"groupChatButton"}, {"type":"Action.OpenUrl","title":"Open in Web"}],"spacing":"Small","horizontalAlignment":"Left"}],"msteams":{"width":"Full"},"$schema":"https://adaptivecards.io/schemas/adaptive-card.json","version":"1.4"},
  ApprovalTicketNotificationCard_tva_approver:{"type":"AdaptiveCard","body":[{"type":"Container","style":"emphasis","items":[{"id":"customTitle","type":"TextBlock","size":"Medium","weight":"Bolder","text":"#Title#","spacing":"Small","wrap":true},{"type":"TextBlock","text":"You have been added as an approver","wrap":true,"spacing":"Small"}],"spacing":"Small","bleed":true},{"type":"TextBlock","size":"Medium","weight":"Bolder","text":"[Active] : Ticket #70402","wrap":true},{"type":"ColumnSet","columns":[{"type":"Column","items":[{"type":"Image","style":"Person","url":AdeleIgm,"size":"Small"}],"width":"auto"},{"type":"Column","items":[{"type":"TextBlock","weight":"Bolder","text":"Miriam Graham","wrap":true,"size":"Medium"},{"type":"TextBlock","spacing":"None","text":"Created on {{DATE(2023-10-03T15:41:48Z,SHORT)}}","isSubtle":true,"wrap":true,"size":"Small"}],"width":"stretch"}]},{"id":"customBody","type":"TextBlock","text":"#Body#","wrap":true},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"Approve","id":"AcceptApproval","data":{"approverId":"${approverId}","ticketId":70307,"commandId":"AcceptApproval","approvalId":10027,"assigneeName":"Lee Gu","requesterImage":AdeleIgm,"requesterName":"Miriam Graham","ticketCreationDate":"2023-10-03T15:41:48Z","title":"#70402 - Not Receiving Email Notifications"}},{"type":"Action.Submit","title":"Reject","id":"RejectApproval","data":{"approverId":"${approverId}","ticketId":70307,"commandId":"RejectApproval","approvalId":10027,"assigneeName":"Lee Gu","requesterImage":AdeleIgm,"requesterName":"Miriam Graham","ticketCreationDate":"2023-10-03T15:41:48Z","title":"#70402 - Not Receiving Email Notifications"}},{"type":"Action.Submit","title":"View Ticket","url":"https://a896-222-127-223-6.ngrok-free.app/requests/70402"}, {"type":"Action.OpenUrl","title":"Open Group Chat", "id":"groupChatButton"}, {"type":"Action.OpenUrl","title":"Open in Web"}],"spacing":"Small","horizontalAlignment":"Left"}],"msteams":{"width":"Full"},"$schema":"https://adaptivecards.io/schemas/adaptive-card.json","version":"1.4"},

  CommentCardJson:{"type":"AdaptiveCard","body":[{"type":"ColumnSet","columns":[{"type":"Column","width":"stretch","items":[{"id":"customTitle","type":"TextBlock","weight":"Bolder","text":"#Title#","wrap":true}]}]},{"type":"TextBlock","size":"Large","weight":"Bolder","text":"[Active]: Ticket #70402","wrap":true},{"type":"TextBlock","text":"Modified {{DATE(2023-10-02T10:17:21Z,SHORT)}} at {{TIME(2023-10-02T10:17:21Z)}}","wrap":true,"size":"Small","spacing":"None"},{"type":"ColumnSet","columns":[{"type":"Column","items":[{"type":"Image","style":"Person","url":AdeleIgm,"size":"Small"}],"width":"auto"},{"type":"Column","items":[{"type":"TextBlock","weight":"Bolder","text":"Adele Vance","wrap":true},{"type":"TextBlock","spacing":"None","text":"Created {{DATE(2023-09-26T14:40:25Z, SHORT)}}","wrap":true}],"width":"stretch"}]},{"id":"customBody","type":"TextBlock","text":"#Body#","wrap":true},{"type":"Container","items":[{"type":"TextBlock","text":" "},{"type":"TextBlock","text":" ","spacing":"None","separator":true},{"type":"ColumnSet","columns":[{"type":"Column","width":"auto","items":[{"type":"Image","style":"Person","url":AdeleIgm,"size":"small"}]},{"type":"Column","width":"stretch","items":[{"type":"ColumnSet","columns":[{"type":"Column","items":[{"type":"TextBlock","text":"**Lee Gu** {{DATE(2023-09-26T14:45:57Z,SHORT)}} at {{TIME(2023-09-26T14:45:57Z)}}","wrap":true}]}]},{"type":"TextBlock","text":"Confirmed issue!","spacing":"None","wrap":true}]}]}]},{"type":"Container","style":"default","items":[{"type":"ColumnSet","columns":[{"type":"Column","verticalContentAlignment":"Center","width":1,"items":[{"type":"TextBlock","id":"showFullConversation","color":"Accent","text":"Show Full Conversation (1 comment(s))","wrap":true,"size":"Small"}]}],"spacing":"None","selectAction":{"type":"Action.Submit","data":{"TicketId":70306,"commandId":"ViewFullConversation","msteams":{"type":"task/fetch"}}}},{"type":"ActionSet","spacing":"medium","actions":[{"type":"Action.Submit","title":"Add Attachment","data":{"ticket":70306,"text":"Send me the file you would like attached to ticket 70402","commandId":"NotifyToAddFile"}},{"type":"Action.Submit","title":"View"}, {"type":"Action.OpenUrl","title":"Open Group Chat", "id":"groupChatButton"}, {"type":"Action.OpenUrl","title":"Open in Web"}]},{"type":"Container","id":"replyContainer","items":[{"type":"TextBlock","text":"Reply to Ticket","weight":"Bolder","wrap":true},{"type":"Input.Text","id":"comment","placeholder":"Add a comment","isMultiline":true},{"type":"Input.Toggle","title":"Private","id":"private","value":"false","valueOn":"true","valueOff":"false"},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"Send","id":"AddComment","data":{"ticket":70306,"commandId":"AddComment","FilterValue":"${FilterValue}","SearchText":"${SearchText}","HideChatWithButton":"${HideChatWithButton}","HideAttachmentButton":"${HideAttachmentButton}","HideMeetingButton":"${HideMeetingButton}"}},{"type":"Action.Submit","title":"Send & Add to KB","id":"AddCommentAndKB","data":{"ticket":70306,"question":"Not Receiving Email Notifications","commandId":"AddCommentAndKB","FilterValue":"${FilterValue}","SearchText":"${SearchText}","HideChatWithButton":"${HideChatWithButton}","HideAttachmentButton":"${HideAttachmentButton}","HideMeetingButton":"${HideMeetingButton}","fromMessageExtension":"${fromMsgExt}","msteams":{"type":"task/fetch"}}}]}],"style":"emphasis","isVisible":true},{"type":"Container","items":[{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"HiddenButton","id":"HiddenButton"}],"isVisible":false}],"isVisible":false}]}],"msteams":{"width":"Full"},"$schema":"https://adaptivecards.io/schemas/adaptive-card.json","version":"1.4"},
  CommentCardJson_tva:{"type":"AdaptiveCard","body":[{"type":"ColumnSet","columns":[{"type":"Column","width":"stretch","items":[{"id":"customTitle","type":"TextBlock","weight":"Bolder","text":"#Title#","wrap":true}],}]},{"type":"TextBlock","size":"Large","weight":"Bolder","text":"[Active]: Ticket #70402","wrap":true},{"type":"TextBlock","text":"Modified {{DATE(2023-10-02T10:17:21Z,SHORT)}} at {{TIME(2023-10-02T10:17:21Z)}}","wrap":true,"size":"Small","spacing":"None"},{"type":"ColumnSet","columns":[{"type":"Column","items":[{"type":"Image","style":"Person","url":AdeleIgm,"size":"Small"}],"width":"auto"},{"type":"Column","items":[{"type":"TextBlock","weight":"Bolder","text":"Adele Vance","wrap":true},{"type":"TextBlock","spacing":"None","text":"Created {{DATE(2023-09-26T14:40:25Z, SHORT)}}","wrap":true}],"width":"stretch"}]},{"id":"customBody","type":"TextBlock","text":"#Body#","wrap":true},{"type":"Container","items":[{"type":"TextBlock","text":" "},{"type":"TextBlock","text":" ","spacing":"None","separator":true},{"type":"ColumnSet","columns":[{"type":"Column","width":"auto","items":[{"type":"Image","style":"Person","url":AdeleIgm,"size":"small"}]},{"type":"Column","width":"stretch","items":[{"type":"ColumnSet","columns":[{"type":"Column","items":[{"type":"TextBlock","text":"**Lee Gu** {{DATE(2023-09-26T14:45:57Z,SHORT)}} at {{TIME(2023-09-26T14:45:57Z)}}","wrap":true}]}]},{"type":"TextBlock","text":"Confirmed issue!","spacing":"None","wrap":true}]}]}]},{"type":"Container","style":"default","items":[{"type":"ColumnSet","columns":[{"type":"Column","verticalContentAlignment":"Center","width":1,"items":[{"type":"TextBlock","id":"showFullConversation","color":"Accent","text":"Show Full Conversation (1 comment(s))","wrap":true,"size":"Small"}]}],"spacing":"None","selectAction":{"type":"Action.Submit","data":{"TicketId":70306,"commandId":"ViewFullConversation","msteams":{"type":"task/fetch"}}}},{"type":"ActionSet","spacing":"medium","actions":[{"type":"Action.Submit","title":"Add Attachment","data":{"ticket":70306,"text":"Send me the file you would like attached to ticket 70402","commandId":"NotifyToAddFile"}},{"type":"Action.Submit","title":"View"}, {"type":"Action.OpenUrl","title":"Open Group Chat", "id":"groupChatButton"}, {"type":"Action.OpenUrl","title":"Open in Web"}]},{"type":"Container","id":"replyContainer","items":[{"type":"TextBlock","text":"Reply to Ticket","weight":"Bolder","wrap":true},{"type":"Input.Text","id":"comment","placeholder":"Add a comment","isMultiline":true},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"Send","id":"AddComment","data":{"ticket":70306,"commandId":"AddComment","FilterValue":"${FilterValue}","SearchText":"${SearchText}","HideChatWithButton":"${HideChatWithButton}","HideAttachmentButton":"${HideAttachmentButton}","HideMeetingButton":"${HideMeetingButton}"}},]}],"style":"emphasis","isVisible":true},{"type":"Container","items":[{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"HiddenButton","id":"HiddenButton"}],"isVisible":false}],"isVisible":false}]}],"msteams":{"width":"Full"},"$schema":"https://adaptivecards.io/schemas/adaptive-card.json","version":"1.4"},
  
  AnalystCardJson_tva:{"type":"AdaptiveCard","body":[{"id":"customTitle","type":"TextBlock","text":"#Title#","weight":"Bolder","wrap":true},{"type":"TextBlock","size":"Large","weight":"Bolder","text":"[Active]: Ticket #70402","wrap":true},{"type":"ColumnSet","columns":[{"type":"Column","items":[{"type":"Image","style":"Person","url":AdeleIgm,"size":"Small"}],"width":"auto"},{"type":"Column","items":[{"type":"TextBlock","weight":"Bolder","text":"Adele Vance","wrap":true},{"type":"TextBlock","spacing":"None","text":"Created {{DATE(2023-10-12T16:17:02Z, SHORT)}}","wrap":true}],"width":"stretch"}]},{"id":"customBody","type":"TextBlock","text":"#Body#","wrap":true},{"type":"TextBlock","text":" "},{"type":"FactSet","facts":[{"title":"Attachments:","value":"&nbsp;&nbsp;&nbsp;None"}],"spacing":"None"},{"type":"TextBlock","text":"Custom Form Answers:","wrap":true,"weight":"Bolder","size":"Large"},{"type":"FactSet","facts":[{"title":"First Name:","value":"John"},{"title":"Last Name:","value":"McDonald"},{"title":"Job Title:","value":"Developer"}]},{"type":"TextBlock","text":" "},{"type":"Container","style":"default","items":[{"type":"ActionSet","spacing":"Medium","actions":[{"type":"Action.Submit","title":"Add Attachment","data":{"ticket":70312,"text":"Send me the file you would like to attach to ticket 70402","commandId":"NotifyToAddFile"}}, {"type":"Action.OpenUrl","title":"Open Group Chat", "id":"groupChatButton"}, {"type":"Action.OpenUrl","title":"Open in Web"}]},{"type":"Container","style":"default","items":[{"type":"Container","id":"changeStatusContainer","items":[{"type":"TextBlock","text":"Change Status","weight":"Bolder","wrap":true},{"type":"Input.ChoiceSet","choices":[{"title":"Active","value":17},{"title":"-- active 12","value":45},{"title":"-- active 2","value":52},{"title":"Pending","value":18},{"title":"On Hold","value":44},{"title":"Resolved","value":19},{"title":"Closed","value":20}],"value":"17","id":"changeStatusOptions"},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"OK","id":"ChangeStatus","data":{"ticket":70312,"commandId":"ChangeStatus","FilterValue":"${FilterValue}","SearchText":"${SearchText}"}}]}],"style":"emphasis","isVisible":false},{"type":"Container","id":"replyContainer","items":[{"type":"TextBlock","text":"Reply to Ticket","weight":"Bolder","wrap":true},{"type":"Input.Text","id":"comment","placeholder":"Add a comment","isMultiline":true},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"Send","id":"AddComment","data":{"ticket":70312,"commandId":"AddComment","FilterValue":"${FilterValue}","SearchText":"${SearchText}"}}]}],"style":"emphasis"}]},{"type":"Container","items":[{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"HiddenButton","id":"HiddenButton"}],"isVisible":false}],"isVisible":false}]}],"msteams":{"width":"Full"},"$schema":"https://adaptivecards.io/schemas/adaptive-card.json","version":"1.6"},
  AnalystCardJson_tikit:{"type":"AdaptiveCard","body":[{"type":"ColumnSet","columns":[{"type":"Column","width":"stretch","items":[{"id":"customTitle","type":"TextBlock","text":"#Title#","weight":"Bolder","wrap":true},{"type":"TextBlock","size":"large","weight":"bolder","text":"[Active]: Ticket #70402","wrap":true}]}]},{"type":"ColumnSet","columns":[{"type":"Column","items":[{"type":"Image","style":"Person","url":AdeleIgm,"size":"Small"}],"width":"auto"},{"type":"Column","items":[{"type":"TextBlock","weight":"Bolder","text":"Adele Vance","wrap":true},{"type":"TextBlock","spacing":"None","text":"Created {{DATE(2023-09-26T14:40:25Z, SHORT)}}","wrap":true}],"width":"stretch"}]},{"id":"customBody","type":"TextBlock","text":"#Body#","wrap":true},{"type":"TextBlock","text":" "},{"type":"Container","items":[{"type":"ColumnSet","spacing":"none","columns":[{"type":"Column","width":"2","items":[{"type":"TextBlock","text":"Attachments :","weight":"bolder"}]},{"type":"Column","width":7,"items":[{"type":"TextBlock","text":"None","color":"default","weight":"default"}]}]},{"type":"ColumnSet","spacing":"none","columns":[{"type":"Column","width":"1","items":[{"type":"TextBlock","text":" ","weight":"bolder"}]}]}]},{"type":"TextBlock","text":"Custom Form Answers:","wrap":true,"weight":"Bolder","size":"Large"},{"type":"FactSet","facts":[{"title":"First Name:","value":"John"},{"title":"Last Name:","value":"McDonald"},{"title":"Job Title:","value":"Developer"}]},{"type":"ActionSet","id":"ticketActionsContainer1","spacing":"Large","separator":true,"actions":[{"type":"Action.Submit","id":"UnassignTicket","title":"Unassign","data":{"ticket":70306,"commandId":"UnassignTicket"}},{"type":"Action.Submit","title":"Add Attachment","data":{"ticket":70306,"text":"Send me the file you would like attached to ticket 70402","commandId":"NotifyToAddFile"}},{"type":"Action.ToggleVisibility","id":"modifyBtnId","title":"Modify","targetElements":[{"elementId":"replyContainer","isVisible":true},{"elementId":"tagContainer","isVisible":false},{"elementId":"displayConfirmContainer","isVisible":false},{"elementId":"displayAddTaskContainer","isVisible":false},"modifyContainer"]}, {"type":"Action.OpenUrl","title":"Open Group Chat", "id":"groupChatButton"}, {"type":"Action.OpenUrl","title":"Open in Web"}]},{"type":"ActionSet","id":"ticketActionsContainer2","actions":[{"type":"Action.ToggleVisibility","id":"addtagsBtnId","title":"Tag","targetElements":[{"elementId":"replyContainer","isVisible":true},{"elementId":"modifyContainer","isVisible":false},{"elementId":"displayAddTaskContainer","isVisible":false},"tagContainer"]},{"type":"Action.ToggleVisibility","id":"addtasksBtnId","title":"Add Task","targetElements":[{"elementId":"replyContainer","isVisible":true},{"elementId":"modifyContainer","isVisible":false},{"elementId":"tagContainer","isVisible":false},"displayAddTaskContainer"]},{"type":"Action.Submit","id":"AddApproval","title":"Add Approval","data":{"ticket":70306,"commandId":"AddApproval","msteams":{"type":"task/fetch"}}},{"type":"Action.OpenUrl","id":"ChatWithRequesterId","title":"Chat with Adele","url":"https://teams.cloud.microsoft/l/chat/0/0?users=AdeleV@domayn.onmicrosoft.com"}]},{"type":"Container","style":"default","id":"displayActionsContainer","items":[{"type":"Container","id":"modifyContainer","items":[{"type":"TextBlock","text":"Modify this Ticket","weight":"Bolder"},{"type":"ColumnSet","columns":[{"type":"Column","width":"80px","items":[{"type":"TextBlock","text":"Status","wrap":true}],"height":"stretch","verticalContentAlignment":"Center"},{"type":"Column","width":"stretch","items":[{"type":"Input.ChoiceSet","choices":[{"title":"Active","value":17},{"title":"-- active 12","value":45},{"title":"-- active 2","value":52},{"title":"Pending","value":18},{"title":"Resolved","value":19},{"title":"Closed","value":20},{"title":"On Hold","value":44}],"value":"17","id":"changeStatusOptions","style":"compact"}]}]},{"type":"ColumnSet","isVisible":true,"columns":[{"type":"Column","width":"80px","items":[{"type":"TextBlock","text":"Type","wrap":true}],"height":"stretch","verticalContentAlignment":"Center"},{"type":"Column","width":"stretch","items":[{"type":"Input.ChoiceSet","choices":[{"title":"(none)","value":0},{"title":"type 1","value":70},{"title":"Incident","value":71},{"title":"Request","value":72},{"title":"Change","value":73}],"value":"70","id":"changeTicketTypeOptions","style":"compact"}]}]},{"type":"ColumnSet","isVisible":true,"columns":[{"type":"Column","width":"80px","items":[{"type":"TextBlock","text":"Category","wrap":true}],"verticalContentAlignment":"Center","height":"stretch"},{"type":"Column","width":"stretch","items":[{"type":"Input.ChoiceSet","choices":[{"title":"Networking","value":1},{"title":"Onboarding","value":2},{"title":"Permissions","value":3},{"title":"Printing","value":4},{"title":"Software","value":5}],"value":"3","id":"changeCategoryOptions","style":"compact"}]}]},{"type":"ColumnSet","isVisible":true,"columns":[{"type":"Column","width":"80px","items":[{"type":"TextBlock","text":"Priority","wrap":true}],"verticalContentAlignment":"Center"},{"type":"Column","width":"stretch","items":[{"type":"Input.ChoiceSet","choices":[{"title":"1 (High)","value":11},{"title":"2 (Medium)","value":12},{"title":"3 (Low)","value":13},{"title":"super high","value":10071}],"value":"12","id":"changePriorityOptions","style":"compact"}]}]},{"type":"ColumnSet","isVisible":true,"columns":[{"type":"Column","width":"80px","items":[{"type":"TextBlock","text":"Team","wrap":true}],"verticalContentAlignment":"Center"},{"type":"Column","width":"stretch","items":[{"type":"Input.ChoiceSet","choices":[{"title":"(none)","value":0},{"title":"domayn","value":1},{"title":"domayn 2","value":20}],"value":"0","id":"changeTeamOptions","style":"compact"}]}]},{"type":"ColumnSet","columns":[{"type":"Column","width":"80px","items":[{"type":"TextBlock","text":"Group","wrap":true}],"verticalContentAlignment":"Center"},{"type":"Column","width":"stretch","items":[{"type":"Input.ChoiceSet","choices":[{"title":"(none)","value":0},{"title":"Group 1","value":10090},{"title":"Group 2-1","value":10091},{"title":"group 4","value":10093}],"value":"0","id":"changeSupportGroupOptions","style":"compact"}]}]},{"type":"ColumnSet","isVisible":true,"columns":[{"type":"Column","width":"80px","items":[{"type":"TextBlock","text":"Assignee","wrap":true}],"verticalContentAlignment":"Center"},{"type":"Column","width":"stretch","items":[{"type":"Input.ChoiceSet","choices":[{"title":"(none)","value":0},{"title":"Lee Gu","value":1},{"title":"Lee Gu","value":4},{"title":"Adele Vance","value":9},{"title":"Patti Fernandez","value":11},{"title":"Diego Siciliani","value":18},{"title":"Lynne Robbins","value":2},{"title":"Pradeep Gupta","value":3},{"title":"Nestor Wilke","value":5},{"title":"Lidia Holloway","value":6},{"title":"Alex Wilber","value":7},{"title":"Test User2","value":8},{"title":"Lucy DiazOliva","value":10},{"title":"Lee Gu","value":12},{"title":"Johanna Lorenz","value":13},{"title":"Miriam Graham","value":14},{"title":"Henrietta Mueller","value":15},{"title":"Megan Bowen","value":16},{"title":"Isaiah Langer","value":17},{"title":"Joni Sherman","value":19},{"title":"Grady Archie","value":20}],"value":"1","id":"changeAssigneeOptions","style":"compact"}]}]},{"type":"ColumnSet","isVisible":true,"columns":[{"type":"Column","width":"80px","items":[{"type":"TextBlock","text":"Due Date","wrap":true}],"verticalContentAlignment":"Center"},{"type":"Column","width":"stretch","items":[{"type":"Input.Date","id":"changeDueDate"}]}]},{"type":"ColumnSet","isVisible":true,"columns":[{"type":"Column","width":"80px","items":[{"type":"TextBlock","text":"Resolution Date","wrap":true}],"verticalContentAlignment":"Center"},{"type":"Column","width":"stretch","items":[{"type":"Input.Date","id":"changeResolutionDate"}]}]},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"OK","id":"ModifyTicket","data":{"ticket":70306,"commandId":"ModifyTicket","FilterValue":"${FilterValue}","SearchText":"${SearchText}","HideChatWithButton":"${HideChatWithButton}","HideAttachmentButton":"${HideAttachmentButton}","HideMeetingButton":"${HideMeetingButton}"}}]}],"style":"emphasis","isVisible":false},{"type":"Container","style":"default","id":"displayAddTaskContainer","isVisible":false,"items":[{"type":"Container","items":[{"type":"TextBlock","text":"Add Task","weight":"Bolder"},{"type":"ColumnSet","columns":[{"type":"Column","width":"80px","items":[{"type":"TextBlock","text":"Title","wrap":true}],"height":"stretch","verticalContentAlignment":"Center"},{"type":"Column","width":"stretch","items":[{"type":"Input.Text","maxLength":500,"id":"taskTitle","placeholder":"Add task title"}]}]},{"type":"ColumnSet","columns":[{"type":"Column","width":"80px","items":[{"type":"TextBlock","text":"Status","wrap":true}],"height":"stretch","verticalContentAlignment":"Center"},{"type":"Column","width":"stretch","items":[{"type":"Input.ChoiceSet","choices":[{"title":"Not Started","value":74},{"title":"In Progress","value":75},{"title":"Completed","value":76},{"title":"Failed","value":77}],"id":"taskStatus","value":74}]}]},{"type":"ColumnSet","columns":[{"type":"Column","width":"80px","items":[{"type":"TextBlock","text":"Assignee","wrap":true}],"verticalContentAlignment":"Center"},{"type":"Column","width":"stretch","items":[{"type":"Input.ChoiceSet","choices":[{"title":"(none)","value":0},{"title":"Lee Gu","value":1},{"title":"Lee Gu","value":4},{"title":"Adele Vance","value":9},{"title":"Patti Fernandez","value":11},{"title":"Diego Siciliani","value":18},{"title":"Lynne Robbins","value":2},{"title":"Pradeep Gupta","value":3},{"title":"Nestor Wilke","value":5},{"title":"Lidia Holloway","value":6},{"title":"Alex Wilber","value":7},{"title":"Test User2","value":8},{"title":"Lucy DiazOliva","value":10},{"title":"Lee Gu","value":12},{"title":"Johanna Lorenz","value":13},{"title":"Miriam Graham","value":14},{"title":"Henrietta Mueller","value":15},{"title":"Megan Bowen","value":16},{"title":"Isaiah Langer","value":17},{"title":"Joni Sherman","value":19},{"title":"Grady Archie","value":20}],"id":"taskAssignee","value":""}]}]},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"OK","id":"AddTask","data":{"ticket":70306,"commandId":"AddTasks","FilterValue":"${FilterValue}","SearchText":"${SearchText}","HideChatWithButton":"${HideChatWithButton}","HideAttachmentButton":"${HideAttachmentButton}","HideMeetingButton":"${HideMeetingButton}"}}]}],"style":"emphasis"},{"type":"TextBlock","text":" "}]},{"type":"Container","id":"tagContainer","items":[{"type":"TextBlock","text":"Tag a Ticket:","weight":"Bolder","wrap":true},{"type":"TextBlock","text":"Tags must be space-delimited","wrap":true,"weight":"Lighter","size":"Small","spacing":"None"},{"type":"Input.Text","id":"tags","placeholder":"Add Tag (Example: Tag1 Tag2)","isMultiline":false},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"OK","id":"AddTags","data":{"ticket":70306,"commandId":"AddTags","FilterValue":"${FilterValue}","SearchText":"${SearchText}","HideChatWithButton":"${HideChatWithButton}","HideAttachmentButton":"${HideAttachmentButton}","HideMeetingButton":"${HideMeetingButton}"}}]}],"style":"emphasis","isVisible":false},{"type":"TextBlock","text":" "}]},{"type":"TextBlock","text":" ","spacing":"None","separator":true},{"type":"Container","items":[{"type":"TextBlock","text":" "},{"type":"ColumnSet","columns":[{"type":"Column","width":"auto","items":[{"type":"Image","url":AdeleIgm,"size":"small","style":"Person"}]},{"type":"Column","width":"stretch","items":[{"type":"ColumnSet","columns":[{"type":"Column","items":[{"type":"TextBlock","text":"**Lee Gu** {{DATE(2023-09-26T14:45:57Z,SHORT)}} at {{TIME(2023-09-26T14:45:57Z)}}","wrap":true}]}]},{"type":"TextBlock","text":"Confirmed issue!","spacing":"None","wrap":true}]}]},{"type":"TextBlock","text":" "},{"type":"TextBlock","text":" ","spacing":"None","separator":true}]},{"type":"Container","style":"default","items":[{"type":"ColumnSet","columns":[{"type":"Column","verticalContentAlignment":"Center","width":1,"items":[{"type":"TextBlock","id":"showFullConversation","color":"Accent","text":"Show Full Conversation (1 comment(s))","wrap":true,"size":"Small"}]}],"spacing":"None","selectAction":{"type":"Action.Submit","data":{"TicketId":70306,"commandId":"ViewFullConversation","msteams":{"type":"task/fetch"}}}},{"type":"ActionSet","spacing":"medium","actions":[]},{"type":"Container","id":"replyContainer","items":[{"type":"TextBlock","text":"Reply to Ticket","weight":"Bolder","wrap":true},{"type":"Input.Text","id":"comment","placeholder":"Add a comment","isMultiline":true},{"type":"Input.Toggle","title":"Private","id":"private","value":"false","valueOn":"true","valueOff":"false"},{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"Send","id":"AddComment","data":{"ticket":70306,"commandId":"AddComment","FilterValue":"${FilterValue}","SearchText":"${SearchText}","HideChatWithButton":"${HideChatWithButton}","HideAttachmentButton":"${HideAttachmentButton}","HideMeetingButton":"${HideMeetingButton}"}},{"type":"Action.Submit","title":"Send & Add to KB","id":"AddCommentAndKB","data":{"ticket":70306,"question":"with custom form - 123 with a1","commandId":"AddCommentAndKB","FilterValue":"${FilterValue}","SearchText":"${SearchText}","HideChatWithButton":"${HideChatWithButton}","HideAttachmentButton":"${HideAttachmentButton}","HideMeetingButton":"${HideMeetingButton}","fromMessageExtension":"${fromMsgExt}","msteams":{"type":"task/fetch"}}}]}],"style":"emphasis","isVisible":true},{"type":"Container","items":[{"type":"ActionSet","actions":[{"type":"Action.Submit","title":"HiddenButton","id":"HiddenButton"}],"isVisible":false}],"isVisible":false}]}],"msteams":{"width":"Full"},"$schema":"https://adaptivecards.io/schemas/adaptive-card.json","version":"1.4"}
};

export const CustomHelpCardConstants = {
  Button_KnowledgeArticle: "KnowledgeArticle",
  Button_NewTicket: "NewTicket",
  Button_Template: "Template",
  Button_MyRequests: "MyRequests",
  Button_OpenURL: "OpenURL",
  Button_KnowledgeArticle_Display: t('bot-configuration.help-card.btn_display_kb'),
  Button_NewTicket_Display: t('bot-configuration.help-card.btn_display_newticket'),
  Button_Template_Display: t('bot-configuration.help-card.btn_display_template'),
  Button_MyRequests_Display: t('bot-configuration.help-card.btn_display_myrequests'),
  Button_OpenURL_Display: t('bot-configuration.help-card.btn_display_openurl'),
  Button_KnowledgeArticle_Description: t('bot-configuration.help-card.btn_description_kb'),
  Button_NewTicket_Description: t('bot-configuration.help-card.btn_description_newticket'),
  Button_Template_Description: t('bot-configuration.help-card.btn_description_template'),
  Button_MyRequests_Description: t('bot-configuration.help-card.btn_description_myrequests'),
  Button_OpenURL_Description: t('bot-configuration.help-card.btn_description_openurl'),
  Scoped_Text: "ScopedText",
  Name_Label: t('bot-configuration.help-card.label_name'),
  Error_Link: t('bot-configuration.help-card.error_link'),
  Team:  t('bot-configuration.help-card.team'),
  Template:  t('bot-configuration.help-card.template'),
  Knowledge:  t('bot-configuration.help-card.knowledge'),
  No_Item:  t('bot-configuration.help-card.no_item'),
  Add_Button:  `${t('bot-configuration.help-card.add')} ${t('bot-configuration.help-card.button')}`,
  Add:  t('bot-configuration.help-card.add'),
  Edit:  t('bot-configuration.help-card.edit'),
  Button:  t('bot-configuration.help-card.button'),
  Loading:  t('common.loading'),
  DefaultEndUserCardHeader: `Tikit Virtual Agent ${t('bot-configuration.help-card.helpCardBanner')}`,
  DefaultEndUserCardBody: `<p>Tikit Virtual Agent ${t('bot-configuration.help-card.helpCardMessage')}</p>
  <p><strong>${t('bot-configuration.help-card.helpCardReqHeading')}</strong></p>
  <p><em>${t('bot-configuration.help-card.helpCardReqSeeTickets')}</em></p>
  <p><em>${t('bot-configuration.help-card.helpCardReqStatusOfTickets')}</em></p>
  <p><em>${t('bot-configuration.help-card.helpCardReqStatusOfRequests')}</em></p>
  <p><strong>${t('bot-configuration.help-card.helpCardSpecificTicketHeading')}:</strong></p>
  <p><em>${t('bot-configuration.help-card.helpCardSpecificTicketViewticket')}</em></p>
  <p><em>${t('bot-configuration.help-card.helpCardSpecificTicketReplyticket')}</em></p>
  <p><strong>${t('bot-configuration.help-card.helpCardNewTicketHeading')}</strong></p>
  <p><em>${toCapitalizeCase(t('bot-configuration.help-card.btn_display_newticket'))}</em></p>
  <p><strong>${t('bot-configuration.help-card.helpCardCommandsHeading')}</strong></p>
  <p><strong>${t('bot-configuration.help-card.helpCardCommandsHelpTitle')}</strong>&nbsp;&nbsp;&nbsp;&nbsp;${t('bot-configuration.help-card.helpCardCommandsHelpDescription')}.</p>
  <p>${t('bot-configuration.help-card.helpCardCommunityNote')}: <a href="https://get.cireson.com/help-center-link-teams/">Tikit Help Center ↗</a>`,
  ResetYes: t('common.buttons.yes'),
  ResetNo: t('common.buttons.no'),
  Delete: t('common.buttons.delete'),
  ResetDefault: t('bot-configuration.help-card.resetDefault'),
  ResetDefaultMessage: t('bot-configuration.help-card.resetDefaultMessage'),
  Text: t('bot-configuration.help-card.text'),
  ScopedSelectedText: t('bot-configuration.help-card.scopedSelectedText')
}

export const AdaptiveCardTexts = {
  REQUIRE_FIELD: t('ticket-details.edit-ticket-form.custom-form-answer.field-required-hint'),
  SEARCH_TAGS:  `${t('common.select')} ${t('ticket.add-ticket.tag')?.toLowerCase()}`,
  SEARCH_COLLABORATORS: t('ticket.add-ticket.collaborators'),
  SEARCH_NAME: t('common.typing-name'),
  SEARCH_WORD: t('common.typing-word'),
  InitiallyVisibleHint: "When unchecked, the field can be accessed after ticket creation. Only agents can view and edit the property.",
  NeedsUpgradeText: "Some features are unavailable in your current plan."
}

export const TicketPropertiesJsonTypeNames = {
  Request: "Request",
  Requester: "Requester",
  AffectedUser: "Affected Users",
  Status: "Status",
  TicketType: "Ticket Type",
  Category: "Category",
  Priority: "Priority",
  Team: "Team",
  Group: "Group",
  Assignment: "Assignment",
  Collaborators: "Collaborators",
  DueDate: "Due Date",
  Tags: "Tags",
  ResolutionDate: "Resolution Date",
  AddComment: "Add Comment",
  AddAttachment: "Add Attachment",
  StatusOfMyRequests: "Status of My Requests",
  SubmitRequest: "Submit Request",
  PeoplePicker: "People Picker"
}
export const ConfigurationName = {
  Resolution: "ServiceDesk.Core.Configuration.ResolutionNoteConfiguration",
  GroupChat: "ServiceDesk.Core.Configuration.GroupChatConfiguration",
  Survey: "ServiceDesk.Core.Configuration.SurveyConfiguration",
  Ticket: "ServiceDesk.Core.Configuration.TicketConfiguration",
}

export const EmptyGuid = "00000000-0000-0000-0000-000000000000";

export const MeToken = "Me";
export const MeTokenId = -1;
export const ScopeTokens = {
  MeTokenData : {
                "displayName": MeToken,
                "mail": MeToken,
                "givenName": "",
                "userPrincipalName": MeToken,
                "surname": "",
                "id": EmptyGuid
            },
  UseMeToken : 
  {
      Id: MeTokenId,
      GivenName: "",
      FamilyName: "",
      Email: MeToken,
      UserName: MeToken,
      AadObjectId: EmptyGuid
  },
  MeTokenPlatformUser : {
      Id: -1,
      FullName: MeToken,
      selected: false,
      AadObjectId: EmptyGuid,
      UserName: MeToken,
    }
}



export const ACTIVITY_ITEMS = 1000;

export const CustomPropertiesAnswerJsonKey = "custompropertiesanswerjson";
export const CustomProperty_TimeInputWrapperClass = (isDarkMode: boolean) =>  `CustomPropertiesContainer ${isDarkMode ? 'cp_DarkContainer' : ''}`;
export const CustomProperty_TimeInputClass = "ui-input__input tikit-input-time";

export const CustomViewType = {
  CompanyView:"CompanyView", MyView:"MyView", ScopedView:"ScopedView", DefaultView:"DefaultView"
}

export const DefaultViewGuid = "e3178b12-c612-487d-9d0d-7aa105006d3a";

export const UserAdminMode = {
  Default:"Default",
  Agent:"Agent",
  Admin:"Admin"
}